import React, { useState, useEffect } from 'react';

const AdminApp = () => {
    // Initialize authentication state from localStorage
    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        return localStorage.getItem('isAdminAuth') === 'true';
    });

    // Initialize activeTab from localStorage, defaulting to 'Dashboard'
    const [activeTab, setActiveTab] = useState(() => {
        return localStorage.getItem('activeAdminTab') || 'Dashboard';
    });

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');












    // --- District Directory CRUD State ---
    // --- District Directory State ---
    const [districts, setDistricts] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    // Fetch districts from the backend API on component mount
    useEffect(() => {
        fetchDistricts();
    }, []);

    const fetchDistricts = async () => {
        try {
            const response = await fetch('https://api.lionsmd320.org/pages/api/districts'
            );

            const data = await response.json();

            if (data.districts) {
                setDistricts(data.districts);
            }
        } catch (error) {
            console.error('Error fetching districts:', error);
            alert('FAILED TO LOAD DISTRICTS FROM SERVER.');
        } finally {
            setIsLoading(false);
        }
    };


    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;

    // Modal & Form State
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [formData, setFormData] = useState({
        district: '',
        districtName: '',
        clubs: '',
        members: '',
        districtChairperson: ''
    });

    // Save district data changes to localStorage
    useEffect(() => {
        localStorage.setItem('districtDirectoryData', JSON.stringify(districts));
    }, [districts]);

    const handleLogin = (e) => {
        e.preventDefault();

        // 1. Check if fields are empty
        if (!email || !password) {
            setError('PLEASE FILL IN ALL FIELDS TO CONTINUE.');
            return;
        }

        // 2. Validate against the static credentials
        if (email !== 'admin@gmail.com' || password !== 'admin320') {
            setError('INVALID EMAIL OR PASSWORD.');
            return;
        }

        // 3. Clear error and proceed with successful login
        setError('');
        setIsAuthenticated(true);
        localStorage.setItem('isAdminAuth', 'true');
    };

    const handleLogout = () => {
        setIsAuthenticated(false);
        localStorage.removeItem('isAdminAuth');
        localStorage.removeItem('activeAdminTab');
        setEmail('');
        setPassword('');
        setActiveTab('Dashboard');
    };

    const handleTabChange = (tabName) => {
        setActiveTab(tabName);
        localStorage.setItem('activeAdminTab', tabName);
        setCurrentPage(1);
        setSearchTerm('');
    };

    // --- CRUD Handlers ---
    const handleOpenAddModal = () => {
        setEditingId(null);
        setFormData({ district: '', districtName: '', clubs: '', members: '', districtChairperson: '' });
        setIsModalOpen(true);
    };

    const handleOpenEditModal = (item) => {
        setEditingId(item.id);
        setFormData({
            district: item.district,
            districtName: item.districtName,
            clubs: item.clubs,
            members: item.members,
            districtChairperson: item.districtChairperson
        });
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setEditingId(null);
    };

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (!formData.district || !formData.districtName || !formData.clubs || !formData.members || !formData.districtChairperson) {
            alert('PLEASE FILL OUT ALL FIELDS.');
            return;
        }

        try {
            if (editingId !== null) {
                // --- UPDATE (PUT) ---
                const response = await fetch(`https://api.lionsmd320.org/pages/api/districts/${editingId}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
                if (!response.ok) throw new Error('Failed to update district');
            } else {
                // --- CREATE (POST) ---
                const response = await fetch('https://api.lionsmd320.org/pages/api/districts', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(formData)
                });
                if (!response.ok) throw new Error('Failed to create district');
            }

            // Refresh the table data from backend
            fetchDistricts();
            handleCloseModal();
        } catch (error) {
            console.error('Error saving district:', error);
            alert('OPERATION FAILED. CHECK CONSOLE.');
        }
    };

    const handleDelete = async (id) => {
        if (window.confirm('ARE YOU SURE YOU WANT TO DELETE THIS DISTRICT RECORD?')) {
            try {
                // --- DELETE ---
                const response = await fetch(`https://api.lionsmd320.org/pages/api/districts/${id}`, {
                    method: 'DELETE'
                });
                if (!response.ok) throw new Error('Failed to delete district');

                // Refresh the table data from backend
                fetchDistricts();
            } catch (error) {
                console.error('Error deleting district:', error);
                alert('FAILED TO DELETE DISTRICT.');
            }
        }
    };

    // --- Search & Pagination Logic ---
    const filteredDistricts = districts.filter(d =>
        d.district.toLowerCase().includes(searchTerm.toLowerCase()) ||
        d.districtName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        d.districtChairperson.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const totalPages = Math.ceil(filteredDistricts.length / rowsPerPage) || 1;
    const startIndex = (currentPage - 1) * rowsPerPage;
    const currentTableData = filteredDistricts.slice(startIndex, startIndex + rowsPerPage);

















    // --- Our Leaders State Declarations ---
    const [leaders, setLeaders] = useState([]);
    const [leadersLoading, setLeadersLoading] = useState(true);
    const [leaderSearch, setLeaderSearch] = useState('');
    const [leaderPage, setLeaderPage] = useState(1);
    const leaderRowsPerPage = 10;

    const [isLeaderModalOpen, setIsLeaderModalOpen] = useState(false);
    const [editingLeaderId, setEditingLeaderId] = useState(null);
    const [leaderForm, setLeaderForm] = useState({ name: '', designation: '' });
    const [leaderImageFile, setLeaderImageFile] = useState(null);

    // Fetch leaders from backend API
    const fetchLeaders = async () => {
        try {
            setLeadersLoading(true);
            const response = await fetch('https://api.lionsmd320.org/pages/api/leaders');
            const data = await response.json();
            if (data.leaders) setLeaders(data.leaders);
        } catch (err) {
            console.error('Failed to fetch leaders', err);
        } finally {
            setLeadersLoading(false);
        }
    };

    useEffect(() => {
        fetchLeaders();
    }, []);

    // Modal & Form Handlers
    const handleOpenAddLeaderModal = () => {
        setEditingLeaderId(null);
        setLeaderForm({ name: '', designation: '' });
        setLeaderImageFile(null);
        setIsLeaderModalOpen(true);
    };

    const handleOpenEditLeaderModal = (leader) => {
        setEditingLeaderId(leader.id);
        setLeaderForm({ name: leader.name, designation: leader.designation });
        setLeaderImageFile(null); // Keep existing image unless a new file is chosen
        setIsLeaderModalOpen(true);
    };

    const handleDeleteLeader = async (id) => {
        if (window.confirm('ARE YOU SURE YOU WANT TO DELETE THIS LEADER?')) {
            try {
                const res = await fetch(`https://api.lionsmd320.org/pages/api/leaders/${id}`, { method: 'DELETE' });
                if (!res.ok) throw new Error('Failed to delete');
                fetchLeaders();
            } catch (err) {
                console.error(err);
                alert('FAILED TO DELETE LEADER.');
            }
        }
    };

    const handleLeaderFormSubmit = async (e) => {
        e.preventDefault();
        if (!leaderForm.name || !leaderForm.designation || (editingLeaderId === null && !leaderImageFile)) {
            alert('PLEASE FILL OUT ALL REQUIRED FIELDS AND SELECT AN IMAGE.');
            return;
        }

        try {
            const formData = new FormData();
            formData.append('name', leaderForm.name);
            formData.append('designation', leaderForm.designation);
            if (leaderImageFile) {
                formData.append('image', leaderImageFile);
            }

            const url = editingLeaderId !== null
                ? `https://api.lionsmd320.org/pages/api/leaders/${editingLeaderId}`
                : 'https://api.lionsmd320.org/pages/api/leaders';
            const method = editingLeaderId !== null ? 'PUT' : 'POST';

            const res = await fetch(url, {
                method,
                body: formData
            });

            if (!res.ok) throw new Error('Failed to save leader');

            fetchLeaders();
            setIsLeaderModalOpen(false);
        } catch (err) {
            console.error(err);
            alert('OPERATION FAILED.');
        }
    };

    // Search & Pagination Calculations
    const filteredLeaders = leaders.filter(l =>
        l.name.toLowerCase().includes(leaderSearch.toLowerCase()) ||
        l.designation.toLowerCase().includes(leaderSearch.toLowerCase())
    );
    const totalLeaderPages = Math.ceil(filteredLeaders.length / leaderRowsPerPage) || 1;
    const leaderStartIndex = (leaderPage - 1) * leaderRowsPerPage;
    const currentLeaderTableData = filteredLeaders.slice(leaderStartIndex, leaderStartIndex + leaderRowsPerPage);

















    // --- International Programs State ---
    // ==========================================
    // SERVICE ACTIVITIES
    // ==========================================
    const serviceActivities = [
        "Hunger Relief",
        "Global Initiative",
        "Environment",
        "Childhood Cancer",
        "Medical Camps",
        "Seminars",
        "Rellies & Awareness",
        "Youth Empowerment",
        "Diabets",
        "Leo",
        "Quest",
        "Leadership Training",
        "Permanent Projects",
        "Vision",
        "Other",
    ];

    const [programs, setPrograms] = useState([]);
    const [programsLoading, setProgramsLoading] = useState(true);
    const [programSearch, setProgramSearch] = useState('');
    const [programPage, setProgramPage] = useState(1);
    const programRowsPerPage = 10;
    const [isProgramModalOpen, setIsProgramModalOpen] = useState(false);
    const [editingProgramId, setEditingProgramId] = useState(null);
    const [programForm, setProgramForm] = useState({
        serviceActivity: '',
        title: '',
        description: ''
    });

    const fetchPrograms = async () => {
        try {
            setProgramsLoading(true);
            const response = await fetch('https://api.lionsmd320.org/pages/api/internationalprograms');
            if (!response.ok) {
                throw new Error('Failed to fetch programs');
            }
            const data = await response.json();
            console.log('PROGRAMS FROM API:', data);
            if (data.programs) {
                setPrograms(data.programs);
            } else {
                setPrograms([]);
            }
        } catch (err) {
            console.error('Failed to fetch international programs:', err);
            alert('FAILED TO LOAD INTERNATIONAL PROGRAMS.');
        } finally {
            setProgramsLoading(false);
        }
    };

    useEffect(() => {
        fetchPrograms();
    }, []);

    const handleOpenAddProgramModal = () => {
        setEditingProgramId(null);
        setProgramForm({
            serviceActivity: '',
            title: '',
            description: ''
        });
        setIsProgramModalOpen(true);
    };

    const handleOpenEditProgramModal = (program) => {
        console.log('EDIT PROGRAM:', program);
        setEditingProgramId(program.id);
        setProgramForm({
            serviceActivity: program.service_activity || program.serviceActivity || '',
            title: program.title || '',
            description: program.description || ''
        });
        setIsProgramModalOpen(true);
    };

    const handleDeleteProgram = async (id) => {
        if (!window.confirm(
            'ARE YOU SURE YOU WANT TO DELETE THIS PROGRAM RECORD?'
        )) {
            return;
        }
        try {
            const response = await fetch(`https://api.lionsmd320.org/pages/api/internationalprograms/${id}`,
                {
                    method: 'DELETE'
                }
            );
            if (!response.ok) {
                throw new Error('Failed to delete program');
            }
            await fetchPrograms();
        } catch (err) {
            console.error('Delete error:', err);
            alert('FAILED TO DELETE PROGRAM.');
        }
    };

    const handleProgramFormSubmit = async (e) => {
        e.preventDefault();
        console.log('FORM DATA BEFORE SAVE:', programForm);
        if (!programForm.serviceActivity.trim()) {
            alert('PLEASE SELECT A SERVICE ACTIVITY.');
            return;
        }
        if (!programForm.title.trim()) {
            alert('PLEASE ENTER A TITLE.');
            return;
        }
        if (!programForm.description.trim()) {
            alert('PLEASE ENTER A DESCRIPTION.');
            return;
        }
        try {
            const url = editingProgramId !== null
                ? `https://api.lionsmd320.org/pages/api/internationalprograms/${editingProgramId}`
                : 'https://api.lionsmd320.org/pages/api/internationalprograms';
            const method = editingProgramId !== null ? 'PUT' : 'POST';
            const requestData = {
                serviceActivity: programForm.serviceActivity.trim(),
                title: programForm.title.trim(),
                description: programForm.description.trim()
            };
            console.log('DATA SENT TO API:', requestData);
            const response = await fetch(url, {
                method: method,
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestData)
            });
            if (!response.ok) {
                const errorText = await response.text();
                console.error('API ERROR:', errorText);
                throw new Error('Failed to save program');
            }
            await fetchPrograms();
            setIsProgramModalOpen(false);
            setEditingProgramId(null);
            setProgramForm({
                serviceActivity: '',
                title: '',
                description: ''
            });
        } catch (err) {
            console.error('Save program error:', err);
            alert('OPERATION FAILED.');
        }
    };

    const filteredPrograms = programs.filter((program) => {
        const search = programSearch.toLowerCase();
        const serviceActivity = program.service_activity || program.serviceActivity || '';
        return (
            (program.title && program.title.toLowerCase().includes(search)) ||
            (program.description && program.description.toLowerCase().includes(search)) ||
            serviceActivity
                .toLowerCase()
                .includes(search)
        );
    });

    const totalProgramPages = Math.ceil(filteredPrograms.length / programRowsPerPage) || 1;
    const programStartIndex = (programPage - 1) * programRowsPerPage;
    const currentProgramTableData = filteredPrograms.slice(programStartIndex, programStartIndex + programRowsPerPage);

















    // --- Districts State ---
    const [districtss, setDistrictss] = useState([]);
    const [districtsLoading, setDistrictsLoading] = useState(true);
    const [districtSearch, setDistrictSearch] = useState('');
    const [districtPage, setDistrictPage] = useState(1);
    const districtRowsPerPage = 10;
    const [isDistrictModalOpen, setIsDistrictModalOpen] = useState(false);
    const [editingDistrictId, setEditingDistrictId] = useState(null);

    // Only one field
    const [districtForm, setDistrictForm] = useState({ district_name: '' });

    const fetchDistrictss = async () => {
        try {
            setDistrictsLoading(true);
            const response = await fetch('https://api.lionsmd320.org/pages/api/districtss');
            const data = await response.json();
            const districtsArray =
                data.districts ||
                data.districtss ||
                (Array.isArray(data) ? data : []);
            setDistrictss(districtsArray);
        } catch (err) {
            console.error('Failed to fetch districts:', err);
        } finally {
            setDistrictsLoading(false);
        }
    };

    useEffect(() => {
        fetchDistrictss();
    }, []);

    const handleOpenAddDistrictModal = () => {
        setEditingDistrictId(null);
        setDistrictForm({ district_name: '' });
        setIsDistrictModalOpen(true);
    };


    const handleOpenEditDistrictModal = (district) => {
        setEditingDistrictId(district.district_name);
        setDistrictForm({ district_name: district.district_name || '' });
        setIsDistrictModalOpen(true);
    };

    const handleDeleteDistrict = async (district_name) => {
        if (window.confirm('ARE YOU SURE YOU WANT TO DELETE THIS DISTRICT?')
        ) {
            try {
                const res = await fetch(`https://api.lionsmd320.org/pages/api/districtss/${encodeURIComponent(district_name)}`,
                    { method: 'DELETE' }
                );
                if (!res.ok) {
                    throw new Error('Failed to delete district');
                }
                await fetchDistrictss();
            } catch (err) {
                console.error(err);
                alert('FAILED TO DELETE DISTRICT.');
            }
        }
    };

    const handleDistrictFormSubmit = async (e) => {
        e.preventDefault();
        if (!districtForm.district_name.trim()) {
            alert('PLEASE ENTER DISTRICT NAME.');
            return;
        }
        try {
            const url =
                editingDistrictId !== null
                    ? `https://api.lionsmd320.org/pages/api/districtss/${editingDistrictId}`
                    : 'https://api.lionsmd320.org/pages/api/districtss';

            const method =
                editingDistrictId !== null ? 'PUT' : 'POST';
            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    district_name: districtForm.district_name
                })
            });

            if (!res.ok) {
                throw new Error('Failed to save district');
            }
            await fetchDistrictss();
            setIsDistrictModalOpen(false);
            setDistrictForm({ district_name: '' });
        } catch (err) {
            console.error(err);
            alert('OPERATION FAILED.');
        }
    };
    const filteredDistrictss = districtss.filter((d) =>
        d.district_name
            ?.toLowerCase().includes(districtSearch.toLowerCase()));
    const totalDistrictPages = Math.ceil(filteredDistrictss.length / districtRowsPerPage) || 1;
    const districtStartIndex = (districtPage - 1) * districtRowsPerPage;
    const currentDistrictTableData = filteredDistrictss.slice(districtStartIndex, districtStartIndex + districtRowsPerPage);
























    // --- District Leadership Team State ---
    const [leadersteam, setLeadersteam] = useState([]);
    const [leadersLoadingteam, setLeadersLoadingteam] = useState(true);
    const [leaderSearchteam, setLeaderSearchteam] = useState('');
    const [leaderPageteam, setLeaderPageteam] = useState(1);
    const leaderRowsPerPageteam = 10;
    const [isLeaderModalOpenteam, setIsLeaderModalOpenteam] = useState(false);
    const [editingLeaderteamId, setEditingLeaderteamId] = useState(null);
    // Form State (18 Inputs & Details)
    const [leaderFormteam, setLeaderFormteam] = useState({
        districtName: '',
        label: '',
        region: '',
        clubs: '',
        members: '',
        name: '',
        designation: '',
        established: '',
        email: '',
        tagline: '',
        fvdg: '',
        svdg: '',
        mobile: '',
        fvdgMobile: '',
        svdgMobile: ''
    });
    // Image States
    const [profileImageFile, setProfileImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState('');
    const [fvdgImageFile, setFvdgImageFile] = useState(null);
    const [fvdgImagePreview, setFvdgImagePreview] = useState('');
    const [svdgImageFile, setSvdgImageFile] = useState(null);
    const [svdgImagePreview, setSvdgImagePreview] = useState('');

    // --- Fetch Data ---
    const fetchLeadersteam = async () => {
        try {
            setLeadersLoadingteam(true);
            const response = await fetch('https://api.lionsmd320.org/pages/api/district-leadership');
            const data = await response.json();
            if (data.leaders) setLeadersteam(data.leaders);
        } catch (err) {
            console.error('Failed to fetch district leadership team', err);
        } finally {
            setLeadersLoadingteam(false);
        }
    };

    useEffect(() => {
        fetchLeadersteam();
    }, []);

    // --- Modal Handlers ---
    const handleOpenAddLeaderModalteam = () => {
        setEditingLeaderteamId(null);
        setLeaderFormteam({
            districtName: '', label: '', region: '', clubs: '', members: '',
            name: '', designation: '', established: '', email: '', tagline: '',
            fvdg: '', svdg: '', mobile: '', fvdgMobile: '', svdgMobile: ''
        });
        setProfileImageFile(null);
        setImagePreview('');
        setFvdgImageFile(null);
        setFvdgImagePreview('');
        setSvdgImageFile(null);
        setSvdgImagePreview('');
        setIsLeaderModalOpenteam(true);
    };

    const handleOpenEditLeaderModalteam = (leader) => {
        setEditingLeaderteamId(leader.id);
        setLeaderFormteam({
            districtName: leader.district_name || leader.districtName || '',
            label: leader.label || '',
            region: leader.region || '',
            clubs: leader.clubs || '',
            members: leader.members || '',
            name: leader.name || '',
            designation: leader.designation || '',
            established: leader.established || '',
            email: leader.email || '',
            tagline: leader.tagline || '',
            fvdg: leader.fvdg || '',
            svdg: leader.svdg || '',
            mobile: leader.mobile || '',
            fvdgMobile: leader.fvdg_mobile || leader.fvdgMobile || '',
            svdgMobile: leader.svdg_mobile || leader.svdgMobile || ''
        });
        setProfileImageFile(null);
        setImagePreview(leader.profile_image || leader.profileImage || '');
        setFvdgImageFile(null);
        setFvdgImagePreview(leader.fvdg_image || leader.fvdgImage || '');
        setSvdgImageFile(null);
        setSvdgImagePreview(leader.svdg_image || leader.svdgImage || '');
        setIsLeaderModalOpenteam(true);
    };

    // --- Safe File Upload Handlers ---
    const handleProfileImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImageFile(file);
            setImagePreview(URL.createObjectURL(file));
        }
    };

    const handleFvdgImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFvdgImageFile(file);
            setFvdgImagePreview(URL.createObjectURL(file));
        }
    };

    const handleSvdgImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSvdgImageFile(file);
            setSvdgImagePreview(URL.createObjectURL(file));
        }
    };

    // --- Delete Handler ---
    const handleDeleteLeaderteam = async (id) => {
        if (window.confirm('ARE YOU SURE YOU WANT TO DELETE THIS LEADER RECORD?')) {
            try {
                const res = await fetch(`https://api.lionsmd320.org/pages/api/district-leadership/${id}`, { method: 'DELETE' });
                if (!res.ok) throw new Error('Failed to delete leader record');
                fetchLeadersteam();
            } catch (err) {
                console.error(err);
                alert('FAILED TO DELETE LEADER.');
            }
        }
    };

    // --- Form Submission ---
    const handleLeaderFormSubmitteam = async (e) => {
        e.preventDefault();
        if (!leaderFormteam.districtName || !leaderFormteam.name || !leaderFormteam.designation) {
            alert('PLEASE FILL OUT REQUIRED FIELDS (District Name, Name, Designation).');
            return;
        }

        try {
            const formData = new FormData();
            Object.keys(leaderFormteam).forEach(key => {
                formData.append(key, leaderFormteam[key]);
            });

            if (profileImageFile) formData.append('profileImage', profileImageFile);
            if (fvdgImageFile) formData.append('fvdgImageFile', fvdgImageFile);
            if (svdgImageFile) formData.append('svdgImageFile', svdgImageFile);

            const url = editingLeaderteamId !== null
                ? `https://api.lionsmd320.org/pages/api/district-leadership/${editingLeaderteamId}`
                : 'https://api.lionsmd320.org/pages/api/district-leadership';
            const method = editingLeaderteamId !== null ? 'PUT' : 'POST';

            const res = await fetch(url, { method, body: formData });
            if (!res.ok) throw new Error('Failed to save record');

            fetchLeadersteam();
            setIsLeaderModalOpenteam(false);
        } catch (err) {
            console.error(err);
            alert('OPERATION FAILED.');
        }
    };

    // --- Search & Pagination Calculations ---
    const filteredLeadersteam = leadersteam.filter(l =>
        (l.name && l.name.toLowerCase().includes(leaderSearchteam.toLowerCase())) ||
        (l.district_name || l.districtName || '').toLowerCase().includes(leaderSearchteam.toLowerCase()) ||
        (l.designation && l.designation.toLowerCase().includes(leaderSearchteam.toLowerCase()))
    );
    const totalLeaderPagesteam = Math.ceil(filteredLeadersteam.length / leaderRowsPerPageteam) || 1;
    const leaderStartIndexteam = (leaderPageteam - 1) * leaderRowsPerPageteam;
    const currentLeaderTableDatateam = filteredLeadersteam.slice(leaderStartIndexteam, leaderStartIndexteam + leaderRowsPerPageteam);








    // --- Multiple Districts State ---
    const [multipleDistricts, setMultipleDistricts] = useState([]);
    const [mdLoading, setMdLoading] = useState(true);
    const [mdSearch, setMdSearch] = useState('');
    const [mdPage, setMdPage] = useState(1);
    const mdRowsPerPage = 10;

    const [isMdModalOpen, setIsMdModalOpen] = useState(false);
    const [editingMdId, setEditingMdId] = useState(null);

    // 6 Multiple Districts Form Inputs
    const [mdForm, setMdForm] = useState({
        title: '',
        description: '',
        districts: '',
        totalClubs: '',
        totalMembers: '',
        fiscalYear: ''
    });

    // Fetch Multiple Districts from backend API
    const fetchMultipleDistricts = async () => {
        try {
            setMdLoading(true);
            const response = await fetch('https://api.lionsmd320.org/pages/api/multiple-districts');
            const data = await response.json();
            if (data.multipleDistricts) setMultipleDistricts(data.multipleDistricts);
        } catch (err) {
            console.error('Failed to fetch multiple districts', err);
        } finally {
            setMdLoading(false);
        }
    };

    useEffect(() => {
        fetchMultipleDistricts();
    }, []);

    // Modal & Form Handlers
    const handleOpenAddMdModal = () => {
        setEditingMdId(null);
        setMdForm({
            title: '',
            description: '',
            districts: '',
            totalClubs: '',
            totalMembers: '',
            fiscalYear: ''
        });
        setIsMdModalOpen(true);
    };

    const handleOpenEditMdModal = (item) => {
        setEditingMdId(item.id);
        setMdForm({
            title: item.title || '',
            description: item.description || '',
            districts: item.districts || '',
            totalClubs: item.total_clubs || item.totalClubs || '',
            totalMembers: item.total_members || item.totalMembers || '',
            fiscalYear: item.fiscal_year || item.fiscalYear || ''
        });
        setIsMdModalOpen(true);
    };

    const handleDeleteMd = async (id) => {
        if (window.confirm('ARE YOU SURE YOU WANT TO DELETE THIS RECORD?')) {
            try {
                const res = await fetch(`https://api.lionsmd320.org/pages/api/multiple-districts/${id}`, { method: 'DELETE' });
                if (!res.ok) throw new Error('Failed to delete record');
                fetchMultipleDistricts();
            } catch (err) {
                console.error(err);
                alert('FAILED TO DELETE RECORD.');
            }
        }
    };

    const handleMdFormSubmit = async (e) => {
        e.preventDefault();
        if (!mdForm.title || !mdForm.fiscalYear) {
            alert('PLEASE FILL OUT ALL REQUIRED FIELDS (Title, Fiscal Year).');
            return;
        }

        try {
            const url = editingMdId !== null
                ? `https://api.lionsmd320.org/pages/api/multiple-districts/${editingMdId}`
                : 'https://api.lionsmd320.org/pages/api/multiple-districts';
            const method = editingMdId !== null ? 'PUT' : 'POST';

            const res = await fetch(url, {
                method,
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(mdForm)
            });

            if (!res.ok) throw new Error('Failed to save record');

            fetchMultipleDistricts();
            setIsMdModalOpen(false);
        } catch (err) {
            console.error(err);
            alert('OPERATION FAILED.');
        }
    };

    // Search & Pagination Calculations
    const filteredMd = multipleDistricts.filter(item =>
        (item.title && item.title.toLowerCase().includes(mdSearch.toLowerCase())) ||
        (item.fiscal_year || item.fiscalYear || '').toLowerCase().includes(mdSearch.toLowerCase())
    );
    const totalMdPages = Math.ceil(filteredMd.length / mdRowsPerPage) || 1;
    const mdStartIndex = (mdPage - 1) * mdRowsPerPage;
    const currentMdTableData = filteredMd.slice(mdStartIndex, mdStartIndex + mdRowsPerPage);












    const [ourTeam_members, setOurTeam_members] = useState([]);
    const [ourTeam_loading, setOurTeam_loading] = useState(true);
    const [ourTeam_search, setOurTeam_search] = useState('');
    const [ourTeam_page, setOurTeam_page] = useState(1);
    const ourTeam_rowsPerPage = 10;

    const [ourTeam_isModalOpen, setOurTeam_isModalOpen] = useState(false);
    const [ourTeam_editingId, setOurTeam_editingId] = useState(null);

    // Form State (Exactly 3 Inputs: Name, Designation)
    const [ourTeam_form, setOurTeam_form] = useState({
        name: '',
        designation: ''
    });

    // Image State & Preview
    const [ourTeam_imageFile, setOurTeam_imageFile] = useState(null);
    const [ourTeam_imagePreview, setOurTeam_imagePreview] = useState('');

    // --- Fetch Data ---
    const fetchOurTeamData = async () => {
        try {
            setOurTeam_loading(true);
            const response = await fetch('https://api.lionsmd320.org/pages/api/ourteam');
            const data = await response.json();
            if (data.team || data.leaders) {
                setOurTeam_members(data.team || data.leaders);
            }
        } catch (err) {
            console.error('Failed to fetch team members', err);
        } finally {
            setOurTeam_loading(false);
        }
    };

    useEffect(() => {
        fetchOurTeamData();
    }, []);

    // --- Modal Handlers ---
    const handleOurTeamOpenAdd = () => {
        setOurTeam_editingId(null);
        setOurTeam_form({ name: '', designation: '' });
        setOurTeam_imageFile(null);
        setOurTeam_imagePreview('');
        setOurTeam_isModalOpen(true);
    };

    const handleOurTeamOpenEdit = (member) => {
        setOurTeam_editingId(member.id);
        setOurTeam_form({
            name: member.name || '',
            designation: member.designation || ''
        });
        setOurTeam_imageFile(null);
        setOurTeam_imagePreview(member.profile_image || member.profileImage || '');
        setOurTeam_isModalOpen(true);
    };

    // --- Safe File Upload Handler ---
    const handleOurTeamImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setOurTeam_imageFile(file);
            setOurTeam_imagePreview(URL.createObjectURL(file));
        }
    };

    // --- Delete Handler ---
    const handleOurTeamDelete = async (id) => {
        if (window.confirm('ARE YOU SURE YOU WANT TO DELETE THIS TEAM MEMBER?')) {
            try {
                const res = await fetch(`https://api.lionsmd320.org/pages/api/ourteam/${id}`, { method: 'DELETE' });
                if (!res.ok) throw new Error('Failed to delete member');
                fetchOurTeamData();
            } catch (err) {
                console.error(err);
                alert('FAILED TO DELETE RECORD.');
            }
        }
    };

    // --- Form Submission ---
    const handleOurTeamSubmit = async (e) => {
        e.preventDefault();
        if (!ourTeam_form.name || !ourTeam_form.designation) {
            alert('PLEASE FILL OUT REQUIRED FIELDS (Name and Designation).');
            return;
        }

        try {
            const formData = new FormData();
            formData.append('name', ourTeam_form.name);
            formData.append('designation', ourTeam_form.designation);

            if (ourTeam_imageFile) {
                formData.append('profileImage', ourTeam_imageFile);
            }

            const url = ourTeam_editingId !== null
                ? `https://api.lionsmd320.org/pages/api/ourteam/${ourTeam_editingId}`
                : 'https://api.lionsmd320.org/pages/api/ourteam';
            const method = ourTeam_editingId !== null ? 'PUT' : 'POST';

            const res = await fetch(url, { method, body: formData });
            if (!res.ok) throw new Error('Failed to save record');

            fetchOurTeamData();
            setOurTeam_isModalOpen(false);
        } catch (err) {
            console.error(err);
            alert('OPERATION FAILED.');
        }
    };

    // --- Search & Pagination ---
    const filteredOurTeam = ourTeam_members.filter(m =>
        (m.name && m.name.toLowerCase().includes(ourTeam_search.toLowerCase())) ||
        (m.designation && m.designation.toLowerCase().includes(ourTeam_search.toLowerCase()))
    );
    const totalOurTeamPages = Math.ceil(filteredOurTeam.length / ourTeam_rowsPerPage) || 1;
    const ourTeamStartIndex = (ourTeam_page - 1) * ourTeam_rowsPerPage;
    const currentOurTeamTableData = filteredOurTeam.slice(ourTeamStartIndex, ourTeamStartIndex + ourTeam_rowsPerPage);










    // Fetch all activities function (Call this on component mount or tab switch)
    const API_BASE = 'https://api.lionsmd320.org/pages/api/api';

    // State variables
    const [activitiesList, setActivitiesList] = useState([]);
    const [activitiesLoading, setActivitiesLoading] = useState(false);
    const [isEditActivityModalOpen, setIsEditActivityModalOpen] = useState(false);
    const [currentActivityId, setCurrentActivityId] = useState(null);

    const [activityCurrentPage, setActivityCurrentPage] = useState(1);
    const [activityItemsPerPage] = useState(10); // Rows per page


    const [activityFormData, setActivityFormData] = useState({
        district: '',
        activity: '',
        caption: '',
        photo: null
    });

    // Fetch all activities function
    const fetchActivities = async () => {
        setActivitiesLoading(true);

        try {
            const response = await fetch(`${API_BASE}/activities`);
            const text = await response.text();

            if (!response.ok) {
                throw new Error(`GET activities failed: ${response.status} - ${text}`);
            }

            const data = JSON.parse(text);

            setActivitiesList(
                Array.isArray(data.multipleDistricts)
                    ? data.multipleDistricts
                    : []
            );
            setCurrentPage(1); // Reset to page 1 on fresh fetch
        } catch (err) {
            console.error('Error fetching activities:', err);
            setActivitiesList([]);
        } finally {
            setActivitiesLoading(false);
        }
    };

    useEffect(() => {
        if (activeTab === 'Activitiesupload') {
            fetchActivities();
        }
    }, [activeTab]);



    // Open Edit Modal
    const handleOpenEditActivityModal = (item) => {
        console.log('EDIT ITEM:', item);
        console.log('EDIT ID:', item.id);

        if (!item.id) {
            alert('Activity ID is missing');
            return;
        }

        setCurrentActivityId(item.id);

        setActivityFormData({
            district: item.district || '',
            activity: item.activity || '',
            caption: item.caption || '',
            photo: null
        });

        setIsEditActivityModalOpen(true);
    };


    // Handle Update (PUT)
    const handleUpdateActivitySubmit = async (e) => {
        e.preventDefault();

        if (!currentActivityId) {
            alert('Activity ID is missing');
            return;
        }

        const formData = new FormData();

        formData.append('district', activityFormData.district);
        formData.append('activity', activityFormData.activity);
        formData.append('caption', activityFormData.caption);

        if (activityFormData.photo) {
            formData.append('photo', activityFormData.photo);
        }

        console.log('Updating activity ID:', currentActivityId);

        try {
            const response = await fetch(
                `${API_BASE}/activities/${currentActivityId}`,
                {
                    method: 'PUT',
                    body: formData
                }
            );

            const text = await response.text();

            console.log('PUT status:', response.status);
            console.log('PUT response:', text);

            let data = {};

            try {
                data = JSON.parse(text);
            } catch {
                console.error('Server did not return JSON');
            }

            if (!response.ok) {
                throw new Error(
                    data.error || `Update failed: ${response.status}`
                );
            }

            alert('Activity updated successfully');

            setIsEditActivityModalOpen(false);
            setCurrentActivityId(null);

            setActivityFormData({
                district: '',
                activity: '',
                caption: '',
                photo: null
            });

            await fetchActivities();

        } catch (err) {
            console.error('Error updating activity:', err);
            alert(err.message);
        }
    };


    // Handle Delete (DELETE)
    const handleDeleteActivity = async (id) => {
        console.log('DELETE ID:', id);

        if (!id) {
            alert('Activity ID is missing');
            return;
        }

        if (!window.confirm('Are you sure you want to delete this activity?')) {
            return;
        }

        try {
            const response = await fetch(
                `${API_BASE}/activities/${id}`,
                {
                    method: 'DELETE'
                }
            );

            const text = await response.text();

            console.log('DELETE status:', response.status);
            console.log('DELETE response:', text);

            let data = {};

            try {
                data = JSON.parse(text);
            } catch {
                console.error('Server did not return JSON');
            }

            if (!response.ok) {
                throw new Error(
                    data.error || `Delete failed: ${response.status}`
                );
            }

            alert('Activity deleted successfully');

            await fetchActivities();

        } catch (err) {
            console.error('Error deleting activity:', err);
            alert(err.message);
        }
    };

    const handleActivityApproval = async (id, currentStatus) => {
        // Toggle 0 -> 1 or 1 -> 0
        const newStatus = Number(currentStatus) === 1 ? 0 : 1;

        const confirmMessage =
            newStatus === 1
                ? 'Are you sure you want to approve this activity?'
                : 'Are you sure you want to mark this activity as not approved?';

        if (!window.confirm(confirmMessage)) {
            return;
        }

        try {
            const response = await fetch(`https://api.lionsmd320.org/pages/api/api/uploadactivities/${id}/status`,
                {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        isActive: newStatus,
                    }),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(
                    data.error || 'Failed to update activity approval'
                );
            }

            // Refresh table
            fetchActivities();

        } catch (error) {
            console.error('Activity approval error:', error);
            alert(error.message || 'Failed to update activity status.');
        }
    };

    // --- Pagination Calculations ---
    const indexOfLastItem = activityCurrentPage * activityItemsPerPage;
    const indexOfFirstItem = indexOfLastItem - activityItemsPerPage;
    const currentActivities = activitiesList.slice(indexOfFirstItem, indexOfLastItem);
    const activityTotalPages = Math.ceil(activitiesList.length / activityItemsPerPage);
















    const [banners, setBanners] = useState([]);
    const [bannerLoading, setBannerLoading] = useState(true);
    const [bannerSearch, setBannerSearch] = useState('');
    const [bannerPage, setBannerPage] = useState(1);
    const bannerRowsPerPage = 5;

    // Banner Modal & Form State
    const [isBannerModalOpen, setIsBannerModalOpen] = useState(false);
    const [bannerEditingId, setBannerEditingId] = useState(null);
    const [bannerForm, setBannerForm] = useState({
        bannerImage: null,
        tag: 'Disaster Relief',
        title: '',
        description: '',
        cta: '',
        buttonName1: '',
        ctaSecondary: '',
        buttonName2: ''
    });


    // Fetch Banners from API
    const fetchBanners = async () => {
        setBannerLoading(true);
        try {
            const response = await fetch('https://api.lionsmd320.org/pages/api/api/uploadbanner');
            const data = await response.json();
            setBanners(data.multipleDistricts || []);
        } catch (error) {
            console.error('Failed to fetch banners:', error);
        } finally {
            setBannerLoading(false);
        }
    };

    useEffect(() => {
        if (activeTab === 'Homebanners') {
            fetchBanners();
        }
    }, [activeTab]);

    // Modal handlers
    const handleOpenBannerAddModal = () => {
        setBannerEditingId(null);

        setBannerForm({
            bannerImage: null,
            tag: 'Disaster Relief',
            title: '',
            description: '',
            cta: '',
            buttonName1: '',
            ctaSecondary: '',
            buttonName2: ''
        });

        setIsBannerModalOpen(true);
    };


    const handleOpenBannerEditModal = (item) => {
        setBannerEditingId(item.id);

        setBannerForm({
            bannerImage: null,
            tag: item.tag || 'Disaster Relief',
            title: item.title || '',
            description: item.description || '',
            cta: item.cta || '',
            buttonName1: item.buttonName1 || '',
            ctaSecondary: item.ctaSecondary || '',
            buttonName2: item.buttonName2 || ''
        });

        setIsBannerModalOpen(true);
    };


    const handleCloseBannerModal = () => setIsBannerModalOpen(false);

    // Form Submit (Create or Update using FormData)
    const handleBannerFormSubmit = async (e) => {
        e.preventDefault();
        const url = bannerEditingId !== null ? `https://api.lionsmd320.org/pages/api/api/uploadbanner/${bannerEditingId}` : 'https://api.lionsmd320.org/pages/api/api/uploadbanner';
        const method = bannerEditingId !== null ? 'PUT' : 'POST';

        const formData = new FormData();
        if (bannerForm.bannerImage) {
            formData.append('bannerImage', bannerForm.bannerImage);
        }

        formData.append('tag', bannerForm.tag);
        formData.append('title', bannerForm.title);
        formData.append('description', bannerForm.description);

        formData.append('cta', bannerForm.cta);
        formData.append('buttonName1', bannerForm.buttonName1);

        formData.append('ctaSecondary', bannerForm.ctaSecondary);
        formData.append('buttonName2', bannerForm.buttonName2);


        try {
            const response = await fetch(url, {
                method: method,
                // Do NOT set Content-Type header; browser sets it automatically for FormData
                body: formData
            });

            if (response.ok) {
                fetchBanners();
                handleCloseBannerModal();
            } else {
                alert('Operation failed.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
        }
    };

    // Delete Handler
    const handleBannerDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this banner?')) return;
        try {
            const response = await fetch(`https://api.lionsmd320.org/pages/api/api/uploadbanner/${id}`, { method: 'DELETE' });
            if (response.ok) {
                fetchBanners();
            } else {
                alert('Failed to delete.');
            }
        } catch (error) {
            console.error('Error deleting banner:', error);
        }
    };

    // Filter & Pagination Logic
    const filteredBanners = banners.filter(item =>
        (item.title && item.title.toLowerCase().includes(bannerSearch.toLowerCase())) ||
        (item.tag && item.tag.toLowerCase().includes(bannerSearch.toLowerCase()))
    );
    const bannerTotalPages = Math.ceil(filteredBanners.length / bannerRowsPerPage);
    const bannerStartIndex = (bannerPage - 1) * bannerRowsPerPage;
    const currentBannerTableData = filteredBanners.slice(bannerStartIndex, bannerStartIndex + bannerRowsPerPage);













    // Contact Messages State
    const [contactMessages, setContactMessages] = useState([]);
    const [contactMessageLoading, setContactMessageLoading] = useState(true);
    const [contactMessageSearch, setContactMessageSearch] = useState('');
    const [contactMessagePage, setContactMessagePage] = useState(1);
    const contactMessageRowsPerPage = 5;

    // Modal & Form State
    const [isContactMessageModalOpen, setIsContactMessageModalOpen] = useState(false);
    const [contactMessageEditingId, setContactMessageEditingId] = useState(null);
    const [contactMessageForm, setContactMessageForm] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });

    // Fetch Contact Messages from API
    const fetchContactMessages = async () => {
        setContactMessageLoading(true);
        try {
            const response = await fetch('https://api.lionsmd320.org/pages/api/api/contact');
            const data = await response.json();
            // Supports both { contactMessages: [...] } and direct array formats
            setContactMessages(data.contactMessages || data.rows || []);
        } catch (error) {
            console.error('Failed to fetch contact messages:', error);
        } finally {
            setContactMessageLoading(false);
        }
    };

    useEffect(() => {
        // Change 'ContactMessages' to match whatever string your tab uses (e.g., 'ContactMessages' or 'Messages')
        if (activeTab === 'ContactMessages') {
            fetchContactMessages();
        }
    }, [activeTab]);

    // Modal Edit Handler
    const handleOpenContactMessageEditModal = (item) => {
        setContactMessageEditingId(item.id);
        setContactMessageForm({
            name: item.name || '',
            email: item.email || '',
            subject: item.subject || '',
            message: item.message || ''
        });
        setIsContactMessageModalOpen(true);
    };

    const handleCloseContactMessageModal = () => setIsContactMessageModalOpen(false);

    // Form Submit (Update using PUT)
    const handleContactMessageFormSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`https://api.lionsmd320.org/pages/api/api/contact/${contactMessageEditingId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(contactMessageForm)
            });

            if (response.ok) {
                fetchContactMessages();
                handleCloseContactMessageModal();
            } else {
                alert('Failed to update message.');
            }
        } catch (error) {
            console.error('Error updating message:', error);
        }
    };

    // Delete Handler
    const handleContactMessageDelete = async (id) => {
        if (!window.confirm('Are you sure you want to delete this message?')) return;
        try {
            const response = await fetch(`https://api.lionsmd320.org/pages/api/api/contact/${id}`, {
                method: 'DELETE'
            });
            if (response.ok) {
                fetchContactMessages();
            } else {
                alert('Failed to delete message.');
            }
        } catch (error) {
            console.error('Error deleting message:', error);
        }
    };

    // Filter & Pagination Logic
    const filteredContactMessages = contactMessages.filter(item =>
        (item.name && item.name.toLowerCase().includes(contactMessageSearch.toLowerCase())) ||
        (item.email && item.email.toLowerCase().includes(contactMessageSearch.toLowerCase())) ||
        (item.subject && item.subject.toLowerCase().includes(contactMessageSearch.toLowerCase()))
    );
    const contactMessageTotalPages = Math.ceil(filteredContactMessages.length / contactMessageRowsPerPage);
    const contactMessageStartIndex = (contactMessagePage - 1) * contactMessageRowsPerPage;
    const currentContactMessageTableData = filteredContactMessages.slice(contactMessageStartIndex, contactMessageStartIndex + contactMessageRowsPerPage);








// Data & Loading
    const [collabList, setCollabList] = useState([]);
    const [collabLoading, setCollabLoading] = useState(false);

    // Search & Pagination
    const [collabSearchQuery, setCollabSearchQuery] = useState('');
    const [collabPageNum, setCollabPageNum] = useState(1);
    const collabItemsPerPage = 10;

    // Modal & Form States
    const [isCollabModalOpen, setIsCollabModalOpen] = useState(false);
    const [activeCollabItem, setActiveCollabItem] = useState(null); // null = Add mode, Object = Edit mode
    const [collabFormData, setCollabFormData] = useState({ name: '', role: '', introduction: '' });

    // --- Fetch Collaborators on Mount ---
    useEffect(() => {
        fetchCollaborators();
    }, []);

    const fetchCollaborators = async () => {
        setCollabLoading(true);
        try {
            // Adjust URL if your backend uses a prefix like '/api/collaborators'
            const response = await fetch('https://api.lionsmd320.org/pages/api/collaborators');
            const data = await response.json();
            if (response.ok) {
                setCollabList(data.collaborators);
            } else {
                console.error(data.error);
            }
        } catch (err) {
            console.error('Network error fetching collaborators:', err);
        } finally {
            setCollabLoading(false);
        }
    };

    // --- Handlers ---
    const handleOpenCollabAddModal = () => {
        setActiveCollabItem(null);
        setCollabFormData({ name: '', role: '', introduction: '' });
        setIsCollabModalOpen(true);
    };

    const handleOpenCollabEditModal = (item) => {
        setActiveCollabItem(item);
        setCollabFormData({ name: item.name, role: item.role, introduction: item.introduction });
        setIsCollabModalOpen(true);
    };

    const handleCloseCollabModal = () => {
        setIsCollabModalOpen(false);
        setActiveCollabItem(null);
        setCollabFormData({ name: '', role: '', introduction: '' });
    };

    const handleCollabFormSubmit = async (e) => {
        e.preventDefault();
        if (!collabFormData.name || !collabFormData.role) return;

        try {
            if (activeCollabItem) {
                // Update existing entry (PUT)
                const response = await fetch(`https://api.lionsmd320.org/pages/api/collaborators/${activeCollabItem.id}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(collabFormData)
                });
                const data = await response.json();
                
                if (response.ok) {
                    setCollabList(prev => prev.map(item =>
                        item.id === activeCollabItem.id ? data.collaborator : item
                    ));
                    handleCloseCollabModal();
                } else {
                    alert(data.error || 'Failed to update collaborator');
                }
            } else {
                // Add new entry (POST)
                const response = await fetch('https://api.lionsmd320.org/pages/api/collaborators', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(collabFormData)
                });
                const data = await response.json();
                
                if (response.ok) {
                    setCollabList(prev => [data.collaborator, ...prev]);
                    handleCloseCollabModal();
                } else {
                    alert(data.error || 'Failed to add collaborator');
                }
            }
        } catch (err) {
            console.error('Submission error:', err);
            alert('An error occurred while saving.');
        }
    };

    const handleCollabDelete = async (id) => {
        if (window.confirm('Are you sure you want to delete this collaborator?')) {
            try {
                const response = await fetch(`https://api.lionsmd320.org/pages/api/collaborators/${id}`, {
                    method: 'DELETE'
                });
                const data = await response.json();

                if (response.ok) {
                    setCollabList(prev => prev.filter(item => item.id !== id));
                } else {
                    alert(data.error || 'Failed to delete collaborator');
                }
            } catch (err) {
                console.error('Delete error:', err);
                alert('An error occurred while deleting.');
            }
        }
    };

    // --- Filter & Pagination Logic ---
    const filteredCollabData = collabList.filter(item =>
        item.name.toLowerCase().includes(collabSearchQuery.toLowerCase()) ||
        item.role.toLowerCase().includes(collabSearchQuery.toLowerCase())
    );

    const collabTotalPages = Math.ceil(filteredCollabData.length / collabItemsPerPage);
    const collabStartIndex = (collabPageNum - 1) * collabItemsPerPage;
    const currentCollabTableData = filteredCollabData.slice(collabStartIndex, collabStartIndex + collabItemsPerPage);










    // --- Custom Color Palette & Styles ---
    const colors = { royalBlue: '#0066A6', goldenYellow: '#F5C400', white: '#FFFFFF', darkNavy: '#1A1A1A', deepBlue: '#00558C', };
    const styles = {
        menuItem: (isActive) => ({ padding: '8px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', backgroundColor: isActive ? colors.deepBlue : 'transparent', color: isActive ? colors.goldenYellow : colors.white, fontWeight: isActive ? '700' : '500', border: isActive ? `1px solid ${colors.goldenYellow}` : '1px solid transparent', textTransform: 'uppercase', letterSpacing: '0.03em', }),
        tableBtn: (type) => ({ padding: '4px 8px', fontSize: '10px', fontWeight: '700', borderRadius: '4px', border: 'none', cursor: 'pointer', marginRight: '6px', textTransform: 'uppercase', backgroundColor: type === 'edit' ? colors.royalBlue : '#dc2626', color: colors.white, }),
    };

    if (!isAuthenticated) {
        return (
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: colors.royalBlue, fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', fontSize: '12px', }}>
                <div style={{ width: '100%', maxWidth: '360px', padding: '28px', backgroundColor: colors.white, borderRadius: '12px', border: `2px solid ${colors.goldenYellow}`, boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)', boxSizing: 'border-box', }}>
                    <div style={{ textAlign: 'center', marginBottom: '24px', }}>
                        <h1 style={{ fontSize: '16px', fontWeight: '700', color: colors.darkNavy, margin: '0 0 4px 0', textTransform: 'uppercase', letterSpacing: '0.05em', }}>WELCOME BACK</h1>
                        <p style={{ fontSize: '11px', color: colors.deepBlue, margin: '0', textTransform: 'uppercase', letterSpacing: '0.03em', }}>ENTER CREDENTIALS TO ACCESS ADMIN PANEL</p>
                    </div>

                    {error && <div style={{ padding: '10px 12px', marginBottom: '16px', fontSize: '11px', color: '#dc2626', backgroundColor: '#fef2f2', border: '1px solid #fee2e2', borderRadius: '6px', textTransform: 'uppercase', fontWeight: '600', }}>{error}</div>}

                    <form onSubmit={handleLogin}>
                        <div style={{ marginBottom: '16px', }}>
                            <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase', }}>EMAIL ADDRESS</label>
                            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@domain.com" style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none', }} />
                        </div>
                        <div style={{ marginBottom: '16px', }}>
                            <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase', }}>PASSWORD</label>
                            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none', }} />
                        </div>
                        <button type="submit" style={{ width: '100%', padding: '10px', fontSize: '12px', fontWeight: '700', color: colors.darkNavy, backgroundColor: colors.goldenYellow, border: 'none', borderRadius: '8px', cursor: 'pointer', marginTop: '4px', textTransform: 'uppercase', letterSpacing: '0.05em', }}>SIGN IN</button>
                    </form>
                </div>
            </div>
        );
    }

    return (
        <div style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#f0f4f8', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', fontSize: '12px', }}>
            <aside style={{ width: '240px', backgroundColor: colors.royalBlue, borderRight: `2px solid ${colors.goldenYellow}`, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', padding: '24px 16px', boxSizing: 'border-box', position: 'fixed', top: 0, bottom: 0, left: 0, }}>
                <div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '32px', paddingLeft: '8px', }}>
                        <div style={{ width: '10px', height: '10px', backgroundColor: colors.goldenYellow, borderRadius: '50%', border: `1px solid ${colors.darkNavy}`, }}></div>
                        <h2 style={{ fontSize: '14px', fontWeight: '800', color: colors.white, letterSpacing: '0.05em', margin: 0, textTransform: 'uppercase', }}>WORKSPACE</h2>
                    </div>
                    <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '4px', }}>
                        <li style={styles.menuItem(activeTab === 'Dashboard')} onClick={() => handleTabChange('Dashboard')}>DASHBOARD</li>
                        <li style={styles.menuItem(activeTab === 'Homebanners')} onClick={() => handleTabChange('Homebanners')}>Home Banners</li>
                        <li style={styles.menuItem(activeTab === 'District')} onClick={() => handleTabChange('District')}>District Directory</li>
                        <li style={styles.menuItem(activeTab === 'Ourleaders')} onClick={() => handleTabChange('Ourleaders')}>Our Leaders</li>
                        <li style={styles.menuItem(activeTab === 'Ourteam')} onClick={() => handleTabChange('Ourteam')}>Our Team</li>
                        <li style={styles.menuItem(activeTab === 'Multipledistricts')} onClick={() => handleTabChange('Multipledistricts')}>Multiple Districts</li>
                        <li style={styles.menuItem(activeTab === 'Internationalprograms')} onClick={() => handleTabChange('Internationalprograms')}>International Programs</li>
                        <li style={styles.menuItem(activeTab === 'Districtleadershipteam')} onClick={() => handleTabChange('Districtleadershipteam')}>District Leadership Team</li>
                        <li style={styles.menuItem(activeTab === 'Activitiesupload')} onClick={() => handleTabChange('Activitiesupload')}>Activities Upload</li>
                        <li style={styles.menuItem(activeTab === 'ContactMessages')} onClick={() => handleTabChange('ContactMessages')}>Contact Information</li>
                        <li style={styles.menuItem(activeTab === 'Districts')} onClick={() => handleTabChange('Districts')}>Districts</li>

                        <li style={styles.menuItem(activeTab === 'Gatcollaborative')} onClick={() => handleTabChange('Gatcollaborative')}>GAT & COLLABORATIVE GAT</li>
                    </ul>
                </div>

                <div>
                    <button style={{ width: '100%', padding: '8px 12px', backgroundColor: colors.deepBlue, color: colors.goldenYellow, border: `1px solid ${colors.goldenYellow}`, borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '700', textAlign: 'center', textTransform: 'uppercase', letterSpacing: '0.03em', }} onClick={handleLogout}>SIGN OUT</button>
                </div>
            </aside>












            <main style={{ marginLeft: '240px', flex: 1, padding: '32px 40px', boxSizing: 'border-box', }}>
                <h1 style={{ fontSize: '18px', fontWeight: '800', color: colors.darkNavy, letterSpacing: '0.05em', marginBottom: '20px', marginTop: 0, textTransform: 'uppercase', }}>{activeTab.toUpperCase()}</h1>

                {activeTab === 'Dashboard' && (
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '16px', }}>
                        <div style={{ backgroundColor: colors.white, padding: '20px', borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)', }}>
                            <h3 style={{ fontSize: '12px', fontWeight: '700', color: colors.deepBlue, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.03em', margin: '0 0 8px 0', }}>CURRENT VIEW STATUS</h3>
                            <p style={{ fontSize: '11px', color: colors.darkNavy, margin: 0, lineHeight: '1.4', }}>ACTIVE SECTION: <strong>DASHBOARD</strong>. DATA PERSISTED VIA LOCALSTORAGE.</p>
                        </div>
                        <div style={{ backgroundColor: colors.white, padding: '20px', borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)', }}>
                            <h3 style={{ fontSize: '12px', fontWeight: '700', color: colors.deepBlue, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.03em', margin: '0 0 8px 0', }}>SYSTEM METRICS</h3>
                            <p style={{ fontSize: '11px', color: colors.darkNavy, margin: 0, lineHeight: '1.4', }}>SESSION STATUS: <strong>AUTHENTICATED</strong>. UI SCALE: <strong>COMPACT</strong>.</p>
                        </div>
                        <div style={{ backgroundColor: colors.white, padding: '20px', borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)', }}>
                            <h3 style={{ fontSize: '12px', fontWeight: '700', color: colors.deepBlue, marginBottom: '8px', textTransform: 'uppercase', letterSpacing: '0.03em', margin: '0 0 8px 0', }}>QUICK ACTIONS</h3>
                            <p style={{ fontSize: '11px', color: colors.darkNavy, margin: 0, lineHeight: '1.4', }}>CLICK DISTRICT DIRECTORY TO MANAGE RECORDS.</p>
                        </div>
                    </div>
                )}

                {activeTab === 'Homebanners' && (
                    <div>
                        {/* Top Controls */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap' }}>
                            <input
                                type="text"
                                placeholder="SEARCH BANNERS..."
                                value={bannerSearch}
                                onChange={(e) => { setBannerSearch(e.target.value); setBannerPage(1); }}
                                style={{ padding: '8px 12px', fontSize: '12px', borderRadius: '6px', border: `1px solid ${colors.deepBlue}`, width: '260px', outline: 'none', backgroundColor: colors.white }}
                            />
                            <button
                                style={{ padding: '8px 14px', fontSize: '11px', fontWeight: '700', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', cursor: 'pointer', textTransform: 'uppercase' }}
                                onClick={handleOpenBannerAddModal}
                            >
                                + ADD BANNER
                            </button>
                        </div>

                        {/* Table View */}
                        {bannerLoading ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px' }}>LOADING BANNERS...</div>
                        ) : (
                            <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '11px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Banner Image</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Tag</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Headline</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Sub (Description)</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>CTAs</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentBannerTableData.length > 0 ? (
                                            currentBannerTableData.map((item) => (
                                                <tr key={item.id}>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}>
                                                        {item.banner_image ? <img src={item.banner_image} alt="Banner" style={{ width: '45px', height: '28px', objectFit: 'cover', borderRadius: '4px' }} /> : 'No Img'}
                                                    </td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}><span style={{ backgroundColor: '#e0f2fe', color: '#0369a1', padding: '2px 6px', borderRadius: '4px', fontWeight: '600' }}>{item.tag}</span></td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}><strong>{item.title}</strong></td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', maxWidth: '180px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.description}</td>
                                                    <td
                                                        style={{
                                                            padding: '12px 14px',
                                                            borderBottom: '1px solid #e2e8f0',
                                                            fontSize: '10px'
                                                        }}
                                                    >
                                                        <div>
                                                            <strong>{item.buttonName1 || 'Primary'}:</strong>{' '}
                                                            {item.cta || '-'}
                                                        </div>

                                                        <div>
                                                            <strong>{item.buttonName2 || 'Secondary'}:</strong>{' '}
                                                            {item.ctaSecondary || '-'}
                                                        </div>
                                                    </td>

                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}>
                                                        <div style={{ display: 'flex', gap: '6px' }}>
                                                            <button style={{ padding: '4px 8px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => handleOpenBannerEditModal(item)}>Edit</button>
                                                            <button style={{ padding: '4px 8px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => handleBannerDelete(item.id)}>Delete</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr><td colSpan="6" style={{ textAlign: 'center', padding: '24px', color: '#71717a' }}>NO BANNERS FOUND.</td></tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Pagination */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '11px' }}>
                                    <span>PAGE {bannerPage} OF {bannerTotalPages || 1}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700' }} onClick={() => setBannerPage(prev => Math.max(prev - 1, 1))} disabled={bannerPage === 1}>PREV</button>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700' }} onClick={() => setBannerPage(prev => Math.min(prev + 1, bannerTotalPages))} disabled={bannerPage === bannerTotalPages || bannerTotalPages === 0}>NEXT</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'District' && (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap', }}>
                            <input type="text" placeholder="SEARCH DISTRICTS..." value={searchTerm} onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} style={{ padding: '8px 12px', fontSize: '12px', borderRadius: '6px', border: `1px solid ${colors.deepBlue}`, width: '260px', outline: 'none', backgroundColor: colors.white, }} />
                            <button style={{ padding: '8px 14px', fontSize: '11px', fontWeight: '700', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', cursor: 'pointer', textTransform: 'uppercase', }} onClick={handleOpenAddModal}>+ ADD DISTRICT</button>
                        </div>

                        {isLoading ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px' }}>LOADING DISTRICTS FROM DATABASE...</div>
                        ) : (
                            <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)', }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '11px', }}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.03em', }}>District</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.03em', }}>District Name</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.03em', }}>Clubs</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.03em', }}>Members</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.03em', }}>District Chairperson</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '0.03em', }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData.length > 0 ? (
                                            currentTableData.map((item) => (
                                                <tr key={item.id}>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, }}><strong>{item.district}</strong></td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, }}>{item.district_name}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, }}>{item.clubs}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, }}>{item.members}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, }}>{item.district_chairperson}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, }}>
                                                        <button style={styles.tableBtn('edit')} onClick={() => handleOpenEditModal(item)}>Edit</button>
                                                        <button style={styles.tableBtn('delete')} onClick={() => handleDelete(item.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" style={{ ...styles.td, textAlign: 'center', padding: '24px', color: '#71717a' }}>NO DISTRICT RECORDS FOUND.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Pagination Controls */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '11px', }}>
                                    <span>PAGE {currentPage} OF {totalPages || 1}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy, }} onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} disabled={currentPage === 1}>PREV</button>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy, }} onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages || totalPages === 0}>NEXT</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'Ourleaders' && (
                    <div style={{ backgroundColor: '#ffffff', padding: '20px', borderRadius: '12px', border: '1px solid #0066a6', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px', gap: '12px', flexWrap: 'wrap' }}>
                            <input type="text" placeholder="SEARCH LEADERS..." value={leaderSearch} onChange={(e) => { setLeaderSearch(e.target.value); setLeaderPage(1); }} style={{ padding: '10px 14px', borderRadius: '8px', border: '1px solid #d1d5db', outline: 'none', width: '280px', fontSize: '14px' }} />
                            <button style={{ backgroundColor: '#0066a6', color: '#ffffff', border: 'none', padding: '10px 18px', borderRadius: '8px', fontWeight: 'bold', cursor: 'pointer', fontSize: '14px' }} onClick={handleOpenAddLeaderModal}>+ ADD LEADER</button>
                        </div>

                        {leadersLoading ? (
                            <div style={{ backgroundColor: '#ffffff', padding: '24px', borderRadius: '12px', textAlign: 'center', color: '#4b5563', fontWeight: '500' }}>
                                LOADING LEADERS...
                            </div>
                        ) : (
                            <div style={{ overflowX: 'auto', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', backgroundColor: '#ffffff' }}>
                                    <thead>
                                        <tr style={{ backgroundColor: '#f3f4f6', borderBottom: '2px solid #e5e7eb' }}>
                                            <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: 'bold', color: '#374151' }}>Image</th>
                                            <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: 'bold', color: '#374151' }}>Name</th>
                                            <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: 'bold', color: '#374151' }}>Designation</th>
                                            <th style={{ padding: '12px 16px', fontSize: '13px', fontWeight: 'bold', color: '#374151' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentLeaderTableData.length > 0 ? (
                                            currentLeaderTableData.map((item) => (
                                                <tr key={item.id} style={{ borderBottom: '1px solid #e5e7eb' }}>
                                                    <td style={{ padding: '12px 16px' }}>
                                                        <img src={item.image?.startsWith('http') ? item.image : `https://api.lionsmd320.org${item.image}`} alt={item.name} style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #0066a6' }} onError={(e) => { e.currentTarget.src = 'https://via.placeholder.com/36'; }} />
                                                    </td>
                                                    <td style={{ padding: '12px 16px', color: '#1f2937' }}><strong>{item.name}</strong></td>
                                                    <td style={{ padding: '12px 16px', color: '#4b5563' }}>{item.designation}</td>
                                                    <td style={{ padding: '12px 16px', display: 'flex', gap: '8px' }}>
                                                        <button style={{ backgroundColor: '#f59e0b', color: '#ffffff', border: 'none', padding: '6px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => handleOpenEditLeaderModal(item)}>Edit</button>
                                                        <button style={{ backgroundColor: '#ef4444', color: '#ffffff', border: 'none', padding: '6px 12px', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => handleDeleteLeader(item.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{ padding: '24px', textAlign: 'center', color: '#71717a' }}>
                                                    NO LEADERS FOUND.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Pagination Controls */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', backgroundColor: '#f9fafb', borderTop: '1px solid #e5e7eb' }}>
                                    <span style={{ fontSize: '13px', color: '#4b5563', fontWeight: '500' }}>PAGE {leaderPage} OF {totalLeaderPages || 1}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button style={{ padding: '6px 12px', backgroundColor: leaderPage === 1 ? '#e5e7eb' : '#ffffff', color: leaderPage === 1 ? '#9ca3af' : '#374151', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: leaderPage === 1 ? 'not-allowed' : 'pointer' }} onClick={() => setLeaderPage(prev => Math.max(prev - 1, 1))} disabled={leaderPage === 1}>PREV</button>
                                        <button style={{ padding: '6px 12px', backgroundColor: (leaderPage === totalLeaderPages || totalLeaderPages === 0) ? '#e5e7eb' : '#ffffff', color: (leaderPage === totalLeaderPages || totalLeaderPages === 0) ? '#9ca3af' : '#374151', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '12px', fontWeight: 'bold', cursor: (leaderPage === totalLeaderPages || totalLeaderPages === 0) ? 'not-allowed' : 'pointer' }} onClick={() => setLeaderPage(prev => Math.min(prev + 1, totalLeaderPages))} disabled={leaderPage === totalLeaderPages || totalLeaderPages === 0}>NEXT</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'Ourteam' && (
                    <div style={{ backgroundColor: colors.white, padding: '20px', borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>

                        {/* Header Banner */}
                        <div style={{ marginBottom: '16px' }}>
                            <h3 style={{ fontSize: '12px', fontWeight: '700', color: colors.deepBlue, marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.03em', margin: '0 0 4px 0' }}>OUR TEAM MANAGEMENT</h3>
                            <p style={{ fontSize: '11px', color: colors.darkNavy, margin: 0, lineHeight: '1.4' }}>MANAGE TEAM MEMBERS (PROFILE IMAGE, NAME, AND DESIGNATION).</p>
                        </div>

                        {/* Search and Add Controls */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap' }}>
                            <input
                                type="text"
                                placeholder="SEARCH TEAM MEMBERS..."
                                value={ourTeam_search}
                                onChange={(e) => { setOurTeam_search(e.target.value); setOurTeam_page(1); }}
                                style={{ padding: '8px 12px', fontSize: '12px', borderRadius: '6px', border: `1px solid ${colors.deepBlue}`, width: '260px', outline: 'none', backgroundColor: colors.white }}
                            />
                            <button
                                style={{ padding: '8px 14px', fontSize: '11px', fontWeight: '700', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', cursor: 'pointer', textTransform: 'uppercase' }}
                                onClick={handleOurTeamOpenAdd}
                            >
                                + ADD TEAM MEMBER
                            </button>
                        </div>

                        {/* Data Table */}
                        {ourTeam_loading ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px', fontSize: '11px' }}>LOADING TEAM MEMBERS...</div>
                        ) : (
                            <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '11px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Profile Image</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Name</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Designation</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentOurTeamTableData.length > 0 ? (
                                            currentOurTeamTableData.map((item) => (
                                                <tr key={item.id}>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}>
                                                        <img
                                                            src={item.profile_image || item.profileImage || 'https://via.placeholder.com/40'}
                                                            alt={item.name}
                                                            style={{ width: '36px', height: '36px', borderRadius: '50%', objectFit: 'cover', border: `1px solid ${colors.deepBlue}` }}
                                                        />
                                                    </td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, fontWeight: '700' }}>
                                                        {item.name}
                                                    </td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.deepBlue, fontWeight: '700' }}>
                                                        {item.designation}
                                                    </td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}>
                                                        <button style={{ padding: '4px 8px', marginRight: '6px', backgroundColor: '#e0e7ff', color: '#3730a3', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => handleOurTeamOpenEdit(item)}>Edit</button>
                                                        <button style={{ padding: '4px 8px', backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => handleOurTeamDelete(item.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'center', padding: '24px', color: '#71717a' }}>NO TEAM MEMBERS FOUND.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Pagination Controls */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '11px' }}>
                                    <span>PAGE {ourTeam_page} OF {totalOurTeamPages || 1}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button
                                            style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }}
                                            onClick={() => setOurTeam_page(prev => Math.max(prev - 1, 1))}
                                            disabled={ourTeam_page === 1}
                                        >
                                            PREV
                                        </button>
                                        <button
                                            style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }}
                                            onClick={() => setOurTeam_page(prev => Math.min(prev + 1, totalOurTeamPages))}
                                            disabled={ourTeam_page === totalOurTeamPages || totalOurTeamPages === 0}
                                        >
                                            NEXT
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'Multipledistricts' && (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap' }}>
                            <input
                                type="text"
                                placeholder="SEARCH BY TITLE OR FISCAL YEAR..."
                                value={mdSearch}
                                onChange={(e) => { setMdSearch(e.target.value); setMdPage(1); }}
                                style={{ padding: '8px 12px', fontSize: '12px', borderRadius: '6px', border: `1px solid ${colors.deepBlue}`, width: '280px', outline: 'none', backgroundColor: colors.white }}
                            />
                            <button
                                style={{ padding: '8px 14px', fontSize: '11px', fontWeight: '700', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', cursor: 'pointer', textTransform: 'uppercase' }}
                                onClick={handleOpenAddMdModal}
                            >
                                + ADD MULTIPLE DISTRICT
                            </button>
                        </div>

                        {mdLoading ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px' }}>LOADING MULTIPLE DISTRICTS...</div>
                        ) : (
                            <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '11px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Fiscal Year & Title</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Districts</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Stats (Clubs / Members)</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentMdTableData.length > 0 ? (
                                            currentMdTableData.map((item) => (
                                                <tr key={item.id}>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy }}>
                                                        <div style={{ fontSize: '10px', fontWeight: '700', color: colors.deepBlue, textTransform: 'uppercase' }}>{item.fiscal_year || item.fiscalYear}</div>
                                                        <div style={{ fontSize: '12px', fontWeight: 'bold', marginTop: '2px' }}>{item.title}</div>
                                                        <div style={{ fontSize: '10px', color: '#64748b', marginTop: '2px' }}>{item.description}</div>
                                                    </td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, fontWeight: '700' }}>
                                                        {item.districts || 'N/A'}
                                                    </td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy }}>
                                                        <div>Clubs: <strong>{item.total_clubs || item.totalClubs || 0}</strong></div>
                                                        <div style={{ marginTop: '2px' }}>Members: <strong>{item.total_members || item.totalMembers || 0}</strong></div>
                                                    </td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}>
                                                        <button style={styles.tableBtn('edit')} onClick={() => handleOpenEditMdModal(item)}>Edit</button>
                                                        <button style={styles.tableBtn('delete')} onClick={() => handleDeleteMd(item.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'center', padding: '24px', color: '#71717a' }}>NO MULTIPLE DISTRICT RECORDS FOUND.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Pagination Controls */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '11px' }}>
                                    <span>PAGE {mdPage} OF {totalMdPages || 1}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button
                                            style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }}
                                            onClick={() => setMdPage(prev => Math.max(prev - 1, 1))}
                                            disabled={mdPage === 1}
                                        >
                                            PREV
                                        </button>
                                        <button
                                            style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }}
                                            onClick={() => setMdPage(prev => Math.min(prev + 1, totalMdPages))}
                                            disabled={mdPage === totalMdPages || totalMdPages === 0}
                                        >
                                            NEXT
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'Internationalprograms' && (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap' }}>
                            <input type="text" placeholder="SEARCH PROGRAMS..." value={programSearch} onChange={(e) => { setProgramSearch(e.target.value); setProgramPage(1); }} style={{ padding: '8px 12px', fontSize: '12px', borderRadius: '6px', border: `1px solid ${colors.deepBlue}`, width: '260px', outline: 'none', backgroundColor: colors.white }} />
                            <button type="button" style={{ padding: '8px 14px', fontSize: '11px', fontWeight: '700', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', cursor: 'pointer', textTransform: 'uppercase' }} onClick={handleOpenAddProgramModal}>+ ADD PROGRAM</button>
                        </div>
                        {programsLoading ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px' }}>LOADING INTERNATIONAL PROGRAMS...</div>
                        ) : (
                            <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '11px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Service Activity</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Title</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Description</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentProgramTableData.length > 0 ? (currentProgramTableData.map((item) => {
                                            const serviceActivity = item.service_activity || item.serviceActivity || '';
                                            return (
                                                <tr key={item.id}>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, fontWeight: '600' }}>{serviceActivity}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy }}><strong> {item.title} </strong></td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: colors.darkNavy, maxWidth: '400px' }}>{item.description}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}>
                                                        <button type="button" style={styles.tableBtn('edit')} onClick={() => handleOpenEditProgramModal(item)}>Edit</button>
                                                        <button type="button" style={styles.tableBtn('delete')} onClick={() => handleDeleteProgram(item.id)} >Delete</button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'center', padding: '24px', color: '#71717a' }}>NO INTERNATIONAL PROGRAMS FOUND.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '11px' }}>
                                    <span> PAGE {programPage} OF {totalProgramPages}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button type="button" style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }} onClick={() => setProgramPage((prev) => Math.max(prev - 1, 1))} disabled={programPage === 1}>PREV</button>
                                        <button type="button" style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }} onClick={() => setProgramPage((prev) => Math.min(prev + 1, totalProgramPages))} disabled={programPage === totalProgramPages}>NEXT</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'Districts' && (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap' }}>
                            <input type="text" placeholder="SEARCH DISTRICTS..." value={districtSearch} onChange={(e) => { setDistrictSearch(e.target.value); setDistrictPage(1); }} style={{ padding: '8px 12px', fontSize: '12px', borderRadius: '6px', border: `1px solid ${colors.deepBlue}`, width: '260px', outline: 'none', backgroundColor: colors.white }} />
                            <button style={{ padding: '8px 14px', fontSize: '11px', fontWeight: '700', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', cursor: 'pointer', textTransform: 'uppercase' }} onClick={handleOpenAddDistrictModal} >+ ADD DISTRICT</button>
                        </div>
                        {districtsLoading ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px' }}>LOADING DISTRICTS...</div>
                        ) : (
                            <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                                <table
                                    style={{
                                        width: '100%',
                                        borderCollapse: 'collapse',
                                        textAlign: 'left',
                                        fontSize: '11px'
                                    }}
                                >
                                    <thead>
                                        <tr>
                                            <th
                                                style={{
                                                    backgroundColor: colors.royalBlue,
                                                    color: colors.white,
                                                    padding: '12px 14px',
                                                    fontWeight: '700',
                                                    textTransform: 'uppercase'
                                                }}
                                            >
                                                District Name
                                            </th>

                                            <th
                                                style={{
                                                    backgroundColor: colors.royalBlue,
                                                    color: colors.white,
                                                    padding: '12px 14px',
                                                    fontWeight: '700',
                                                    textTransform: 'uppercase'
                                                }}
                                            >
                                                Actions
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentDistrictTableData.length > 0 ? (
                                            currentDistrictTableData.map((item) => (
                                                <tr key={item.id}>
                                                    <td
                                                        style={{
                                                            padding: '12px 14px',
                                                            borderBottom: '1px solid #e2e8f0',
                                                            color: colors.darkNavy,
                                                            fontSize: '13px',
                                                            fontWeight: '700'
                                                        }}
                                                    >
                                                        {item.district_name}
                                                    </td>

                                                    <td
                                                        style={{
                                                            padding: '12px 14px',
                                                            borderBottom: '1px solid #e2e8f0'
                                                        }}
                                                    >
                                                        <button
                                                            style={styles.tableBtn('edit')}
                                                            onClick={() =>
                                                                handleOpenEditDistrictModal(item)
                                                            }
                                                        >
                                                            Edit
                                                        </button>

                                                        <button
                                                            style={styles.tableBtn('delete')}
                                                            onClick={() => handleDeleteDistrict(item.district_name)}
                                                        >
                                                            Delete
                                                        </button>

                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td
                                                    colSpan="2"
                                                    style={{
                                                        textAlign: 'center',
                                                        padding: '24px',
                                                        color: '#71717a'
                                                    }}
                                                >
                                                    NO DISTRICTS FOUND.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>


                                {/* Pagination Controls */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '11px' }}>
                                    <span>PAGE {districtPage} OF {totalDistrictPages || 1}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }} onClick={() => setDistrictPage(prev => Math.max(prev - 1, 1))} disabled={districtPage === 1}>PREV</button>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }} onClick={() => setDistrictPage(prev => Math.min(prev + 1, totalDistrictPages))} disabled={districtPage === totalDistrictPages || totalDistrictPages === 0}>NEXT</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'Districtleadershipteam' && (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap' }}>
                            <input type="text" placeholder="SEARCH LEADERS..." value={leaderSearchteam} onChange={(e) => { setLeaderSearchteam(e.target.value); setLeaderPageteam(1); }} style={{ padding: '8px 12px', fontSize: '12px', borderRadius: '6px', border: `1px solid ${colors.deepBlue}`, width: '260px', outline: 'none', backgroundColor: colors.white }} />
                            <button style={{ padding: '8px 14px', fontSize: '11px', fontWeight: '700', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', cursor: 'pointer', textTransform: 'uppercase' }} onClick={handleOpenAddLeaderModalteam} >+ ADD LEADER</button>
                        </div>

                        {leadersLoadingteam ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px' }}>LOADING LEADERSHIP TEAM...</div>
                        ) : (
                            <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflowX: 'auto', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '11px', minWidth: '950px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 10px', fontWeight: '700', textTransform: 'uppercase' }}>Profiles</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 10px', fontWeight: '700', textTransform: 'uppercase' }}>District Info</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 10px', fontWeight: '700', textTransform: 'uppercase' }}>Governor Details</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 10px', fontWeight: '700', textTransform: 'uppercase' }}>1st & 2nd VDG</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 10px', fontWeight: '700', textTransform: 'uppercase' }}>Stats & Region</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 10px', fontWeight: '700', textTransform: 'uppercase' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentLeaderTableDatateam.length > 0 ? (
                                            currentLeaderTableDatateam.map((item) => (
                                                <tr key={item.id}>
                                                    {/* 1. Profiles (Gov, FVDG, SVDG Images) */}
                                                    <td style={{ padding: '10px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'top' }}>
                                                        <div style={{ display: 'flex', gap: '4px' }}>
                                                            <img src={item.profile_image || item.profileImage || 'https://via.placeholder.com/30'} alt="Gov" title="Governor" style={{ width: '28px', height: '28px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #94a3b8' }} />
                                                            <img src={item.fvdg_image || item.fvdgImage || 'https://via.placeholder.com/30'} alt="FVDG" title="FVDG" style={{ width: '28px', height: '28px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #94a3b8' }} />
                                                            <img src={item.svdg_image || item.svdgImage || 'https://via.placeholder.com/30'} alt="SVDG" title="SVDG" style={{ width: '28px', height: '28px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #94a3b8' }} />
                                                        </div>
                                                    </td>
                                                    <td style={{ padding: '10px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'top', color: colors.darkNavy }}>
                                                        <div style={{ fontWeight: '700' }}>{item.district_name || item.districtName} ({item.label || 'N/A'})</div>
                                                        <div style={{ fontSize: '10px', color: '#64748b' }}>{item.email || 'N/A'}</div>
                                                        <div style={{ fontSize: '10px', color: colors.deepBlue }}>Est: {item.established || 'N/A'}</div>
                                                    </td>
                                                    <td style={{ padding: '10px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'top', color: colors.darkNavy }}>
                                                        <div style={{ fontWeight: 'bold' }}>{item.name || 'N/A'}</div>
                                                        <div style={{ fontSize: '10px', color: colors.deepBlue, fontWeight: '700' }}>{item.designation || 'Governor'}</div>
                                                        <div style={{ fontSize: '10px' }}>Ph: {item.mobile || 'N/A'}</div>
                                                        <div style={{ fontSize: '9px', fontStyle: 'italic', color: '#475569' }}>"{item.tagline || 'No tagline'}"</div>
                                                    </td>
                                                    <td style={{ padding: '10px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'top', color: colors.darkNavy }}>
                                                        <div style={{ fontSize: '10px' }}><strong>FVDG:</strong> {item.fvdg || 'N/A'} ({item.fvdg_mobile || item.fvdgMobile || 'N/A'})</div>
                                                        <div style={{ fontSize: '10px', marginTop: '3px' }}><strong>SVDG:</strong> {item.svdg || 'N/A'} ({item.svdg_mobile || item.svdgMobile || 'N/A'})</div>
                                                    </td>
                                                    <td style={{ padding: '10px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'top', color: colors.darkNavy }}>
                                                        <div><strong>Region:</strong> {item.region || 'N/A'}</div>
                                                        <div style={{ fontSize: '10px', color: '#475569' }}>Clubs: {item.clubs || 0} | Members: {item.members || 0}</div>
                                                    </td>
                                                    <td style={{ padding: '10px', borderBottom: '1px solid #e2e8f0', verticalAlign: 'top' }}>
                                                        <div style={{ display: 'flex', gap: '4px' }}>
                                                            <button style={{ padding: '4px 8px', backgroundColor: '#e0e7ff', color: '#3730a3', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '10px', fontWeight: '700' }} onClick={() => handleOpenEditLeaderModalteam(item)}>Edit</button>
                                                            <button style={{ padding: '4px 8px', backgroundColor: '#fee2e2', color: '#991b1b', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '10px', fontWeight: '700' }} onClick={() => handleDeleteLeaderteam(item.id)}>Delete</button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" style={{ textAlign: 'center', padding: '24px', color: '#71717a' }}>NO LEADERSHIP RECORDS FOUND.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                {/* Pagination Controls */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '11px' }}>
                                    <span>PAGE {leaderPageteam} OF {totalLeaderPagesteam || 1}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }} onClick={() => setLeaderPageteam(prev => Math.max(prev - 1, 1))} disabled={leaderPageteam === 1}>PREV</button>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700', color: colors.darkNavy }} onClick={() => setLeaderPageteam(prev => Math.min(prev + 1, totalLeaderPagesteam))} disabled={leaderPageteam === totalLeaderPagesteam || totalLeaderPagesteam === 0}>NEXT</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'Activitiesupload' && (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap' }}>
                            <h3 style={{ fontSize: '14px', fontWeight: '800', color: colors.darkNavy, margin: 0, textTransform: 'uppercase' }}>
                                Manage Activities
                            </h3>
                        </div>

                        {/* Loading or Table */}
                        {activitiesLoading ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px' }}>
                                LOADING ACTIVITIES...
                            </div>
                        ) : (
                            <div>
                                <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflowX: 'auto', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                                    <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '11px', minWidth: '800px' }}>
                                        <thead>
                                            <tr>
                                                <th
                                                    style={{
                                                        backgroundColor: colors.royalBlue,
                                                        color: colors.white,
                                                        padding: '12px 10px',
                                                        fontWeight: '700',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Photo
                                                </th>

                                                <th
                                                    style={{
                                                        backgroundColor: colors.royalBlue,
                                                        color: colors.white,
                                                        padding: '12px 10px',
                                                        fontWeight: '700',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    District
                                                </th>

                                                <th
                                                    style={{
                                                        backgroundColor: colors.royalBlue,
                                                        color: colors.white,
                                                        padding: '12px 10px',
                                                        fontWeight: '700',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Activity
                                                </th>

                                                <th
                                                    style={{
                                                        backgroundColor: colors.royalBlue,
                                                        color: colors.white,
                                                        padding: '12px 10px',
                                                        fontWeight: '700',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Caption
                                                </th>

                                                <th
                                                    style={{
                                                        backgroundColor: colors.royalBlue,
                                                        color: colors.white,
                                                        padding: '12px 10px',
                                                        fontWeight: '700',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Approval
                                                </th>

                                                <th
                                                    style={{
                                                        backgroundColor: colors.royalBlue,
                                                        color: colors.white,
                                                        padding: '12px 10px',
                                                        fontWeight: '700',
                                                        textTransform: 'uppercase'
                                                    }}
                                                >
                                                    Actions
                                                </th>
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {currentActivities.length > 0 ? (
                                                currentActivities.map((item) => (
                                                    <tr key={item.id}>

                                                        {/* PHOTO */}
                                                        <td
                                                            style={{
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e2e8f0',
                                                                verticalAlign: 'middle'
                                                            }}
                                                        >
                                                            <img
                                                                src={
                                                                    item.imageUrl ||
                                                                    'https://via.placeholder.com/40'
                                                                }
                                                                alt="Activity"
                                                                style={{
                                                                    width: '40px',
                                                                    height: '40px',
                                                                    borderRadius: '6px',
                                                                    objectFit: 'cover',
                                                                    border: '1px solid #94a3b8'
                                                                }}
                                                            />
                                                        </td>

                                                        {/* DISTRICT */}
                                                        <td
                                                            style={{
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e2e8f0',
                                                                verticalAlign: 'middle',
                                                                fontWeight: '700',
                                                                color: colors.darkNavy
                                                            }}
                                                        >
                                                            {item.district}
                                                        </td>

                                                        {/* ACTIVITY */}
                                                        <td
                                                            style={{
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e2e8f0',
                                                                verticalAlign: 'middle',
                                                                color: colors.darkNavy
                                                            }}
                                                        >
                                                            {item.activity}
                                                        </td>

                                                        {/* CAPTION */}
                                                        <td
                                                            style={{
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e2e8f0',
                                                                verticalAlign: 'middle',
                                                                color: '#475569'
                                                            }}
                                                        >
                                                            {item.caption}
                                                        </td>

                                                        {/* APPROVAL STATUS */}
                                                        <td
                                                            style={{
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e2e8f0',
                                                                verticalAlign: 'middle'
                                                            }}
                                                        >
                                                            {Number(item.isActive) === 1 ? (
                                                                <span
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        padding: '4px 9px',
                                                                        borderRadius: '5px',
                                                                        backgroundColor: '#dcfce7',
                                                                        color: '#166534',
                                                                        fontSize: '10px',
                                                                        fontWeight: '800',
                                                                        textTransform: 'uppercase'
                                                                    }}
                                                                >
                                                                    APPROVED
                                                                </span>
                                                            ) : (
                                                                <span
                                                                    style={{
                                                                        display: 'inline-block',
                                                                        padding: '4px 9px',
                                                                        borderRadius: '5px',
                                                                        backgroundColor: '#fee2e2',
                                                                        color: '#991b1b',
                                                                        fontSize: '10px',
                                                                        fontWeight: '800',
                                                                        textTransform: 'uppercase'
                                                                    }}
                                                                >
                                                                    NOT APPROVED
                                                                </span>
                                                            )}
                                                        </td>

                                                        {/* ACTIONS */}
                                                        <td
                                                            style={{
                                                                padding: '10px',
                                                                borderBottom: '1px solid #e2e8f0',
                                                                verticalAlign: 'middle'
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    display: 'flex',
                                                                    gap: '6px',
                                                                    flexWrap: 'wrap'
                                                                }}
                                                            >

                                                                {/* ONE APPROVE / NOT APPROVE BUTTON */}
                                                                <button
                                                                    onClick={() =>
                                                                        handleActivityApproval(
                                                                            item.id,
                                                                            item.isActive
                                                                        )
                                                                    }
                                                                    style={{
                                                                        padding: '4px 10px',
                                                                        backgroundColor:
                                                                            Number(item.isActive) === 1
                                                                                ? '#dc2626'
                                                                                : '#16a34a',
                                                                        color: '#ffffff',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer',
                                                                        fontSize: '10px',
                                                                        fontWeight: '700'
                                                                    }}
                                                                >
                                                                    {Number(item.isActive) === 1
                                                                        ? 'NOT APPROVE'
                                                                        : 'APPROVE'}
                                                                </button>

                                                                {/* EDIT */}
                                                                <button
                                                                    style={{
                                                                        padding: '4px 8px',
                                                                        backgroundColor: '#e0e7ff',
                                                                        color: '#3730a3',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer',
                                                                        fontSize: '10px',
                                                                        fontWeight: '700'
                                                                    }}
                                                                    onClick={() =>
                                                                        handleOpenEditActivityModal(item)
                                                                    }
                                                                >
                                                                    Edit
                                                                </button>

                                                                {/* DELETE */}
                                                                <button
                                                                    style={{
                                                                        padding: '4px 8px',
                                                                        backgroundColor: '#fee2e2',
                                                                        color: '#991b1b',
                                                                        border: 'none',
                                                                        borderRadius: '4px',
                                                                        cursor: 'pointer',
                                                                        fontSize: '10px',
                                                                        fontWeight: '700'
                                                                    }}
                                                                    onClick={() =>
                                                                        handleDeleteActivity(item.id)
                                                                    }
                                                                >
                                                                    Delete
                                                                </button>

                                                            </div>
                                                        </td>

                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td
                                                        colSpan="6"
                                                        style={{
                                                            textAlign: 'center',
                                                            padding: '24px',
                                                            color: '#71717a'
                                                        }}
                                                    >
                                                        NO ACTIVITIES FOUND.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>

                                    </table>
                                </div>

                                {/* Pagination Controls Bar */}
                                {activitiesList.length > 0 && (
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '12px', padding: '4px 8px', fontSize: '11px', color: '#475569', flexWrap: 'wrap', gap: '8px' }}>
                                        <div>
                                            Showing <b>{indexOfFirstItem + 1}</b> to <b>{Math.min(indexOfLastItem, activitiesList.length)}</b> of <b>{activitiesList.length}</b> entries
                                        </div>
                                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                            <button
                                                onClick={() => setActivityCurrentPage(prev => Math.max(prev - 1, 1))}
                                                disabled={activityCurrentPage === 1}
                                                style={{
                                                    padding: '6px 12px',
                                                    backgroundColor: activityCurrentPage === 1 ? '#f1f5f9' : colors.royalBlue,
                                                    color: activityCurrentPage === 1 ? '#94a3b8' : colors.white,
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    cursor: activityCurrentPage === 1 ? 'not-allowed' : 'pointer',
                                                    fontWeight: '700'
                                                }}
                                            >
                                                Previous
                                            </button>

                                            <span style={{ fontWeight: '700', padding: '0 4px' }}>
                                                Page {activityCurrentPage} of {activityTotalPages || 1}
                                            </span>

                                            <button
                                                onClick={() => setActivityCurrentPage(prev => Math.min(prev + 1, activityTotalPages))}
                                                disabled={activityCurrentPage === activityTotalPages || activityTotalPages === 0}
                                                style={{
                                                    padding: '6px 12px',
                                                    backgroundColor: (activityCurrentPage === activityTotalPages || activityTotalPages === 0) ? '#f1f5f9' : colors.royalBlue,
                                                    color: (activityCurrentPage === activityTotalPages || activityTotalPages === 0) ? '#94a3b8' : colors.white,
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    cursor: (activityCurrentPage === activityTotalPages || activityTotalPages === 0) ? 'not-allowed' : 'pointer',
                                                    fontWeight: '700'
                                                }}
                                            >
                                                Next
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'ContactMessages' && (
                    <div>
                        {/* Top Controls / Search */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap' }}>
                            <input type="text" placeholder="SEARCH MESSAGES..." value={contactMessageSearch} onChange={(e) => { setContactMessageSearch(e.target.value); setContactMessagePage(1); }} style={{ padding: '8px 12px', fontSize: '12px', borderRadius: '6px', border: `1px solid ${colors.deepBlue}`, width: '260px', outline: 'none', backgroundColor: colors.white }} />
                        </div>

                        {/* Table View */}
                        {contactMessageLoading ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px' }}>LOADING MESSAGES...</div>
                        ) : (
                            <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '11px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Name</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Email</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Subject</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Message</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Date</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentContactMessageTableData.length > 0 ? (
                                            currentContactMessageTableData.map((item) => (
                                                <tr key={item.id}>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', fontWeight: '600' }}>{item.name}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: '#0369a1' }}>{item.email}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}>{item.subject}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{item.message}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', color: '#64748b' }}>{item.created_at ? item.created_at.replace('T', ' ').substring(0, 19) : ''}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', display: 'flex', gap: '6px' }}>
                                                        <button style={{ padding: '4px 8px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => handleOpenContactMessageEditModal(item)}>Edit</button>
                                                        <button style={{ padding: '4px 8px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }} onClick={() => handleContactMessageDelete(item.id)}>Delete</button>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr><td colSpan="6" style={{ textAlign: 'center', padding: '24px', color: '#71717a' }}>NO MESSAGES FOUND.</td></tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Pagination */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '11px' }}>
                                    <span>PAGE {contactMessagePage} OF {contactMessageTotalPages || 1}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700' }} onClick={() => setContactMessagePage(prev => Math.max(prev - 1, 1))} disabled={contactMessagePage === 1}>PREV</button>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700' }} onClick={() => setContactMessagePage(prev => Math.min(prev + 1, contactMessageTotalPages))} disabled={contactMessagePage === contactMessageTotalPages || contactMessageTotalPages === 0}>NEXT</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}

                {activeTab === 'Gatcollaborative' && (
                    <div>
                        {/* Top Controls */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', gap: '12px', flexWrap: 'wrap' }}>
                            <input
                                type="text"
                                placeholder="SEARCH COLLABORATORS..."
                                value={collabSearchQuery}
                                onChange={(e) => { setCollabSearchQuery(e.target.value); setCollabPageNum(1); }}
                                style={{ padding: '8px 12px', fontSize: '12px', borderRadius: '6px', border: `1px solid ${colors.deepBlue}`, width: '260px', outline: 'none', backgroundColor: colors.white }}
                            />
                            <button
                                style={{ padding: '8px 14px', fontSize: '11px', fontWeight: '700', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', cursor: 'pointer', textTransform: 'uppercase' }}
                                onClick={handleOpenCollabAddModal}
                            >
                                + ADD COLLABORATOR
                            </button>
                        </div>

                        {/* Table View */}
                        {collabLoading ? (
                            <div style={{ padding: '24px', textAlign: 'center', backgroundColor: colors.white, borderRadius: '12px' }}>LOADING COLLABORATORS...</div>
                        ) : (
                            <div style={{ backgroundColor: colors.white, borderRadius: '12px', border: `1px solid ${colors.deepBlue}`, overflow: 'hidden', boxShadow: '0 2px 8px rgba(0, 102, 166, 0.06)' }}>
                                <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'left', fontSize: '11px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Name</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Role</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Introduction</th>
                                            <th style={{ backgroundColor: colors.royalBlue, color: colors.white, padding: '12px 14px', fontWeight: '700', textTransform: 'uppercase' }}>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentCollabTableData.length > 0 ? (
                                            currentCollabTableData.map((item) => (
                                                <tr key={item.id}>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}><strong>{item.name}</strong></td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}>
                                                        <span style={{ backgroundColor: '#e0f2fe', color: '#0369a1', padding: '2px 6px', borderRadius: '4px', fontWeight: '600' }}>{item.role}</span>
                                                    </td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0', maxWidth: '220px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{item.introduction}</td>
                                                    <td style={{ padding: '12px 14px', borderBottom: '1px solid #e2e8f0' }}>
                                                        <div style={{ display: 'flex', gap: '6px' }}>
                                                            <button
                                                                style={{ padding: '4px 8px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                                                onClick={() => handleOpenCollabEditModal(item)}
                                                            >
                                                                Edit
                                                            </button>
                                                            <button
                                                                style={{ padding: '4px 8px', background: '#ef4444', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}
                                                                onClick={() => handleCollabDelete(item.id)}
                                                            >
                                                                Delete
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="4" style={{ textAlign: 'center', padding: '24px', color: '#71717a' }}>NO COLLABORATORS FOUND.</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>

                                {/* Pagination */}
                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 16px', backgroundColor: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '11px' }}>
                                    <span>PAGE {collabPageNum} OF {collabTotalPages || 1}</span>
                                    <div style={{ display: 'flex', gap: '6px' }}>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700' }} onClick={() => setCollabPageNum(prev => Math.max(prev - 1, 1))} disabled={collabPageNum === 1}>PREV</button>
                                        <button style={{ padding: '6px 10px', backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '4px', cursor: 'pointer', fontWeight: '700' }} onClick={() => setCollabPageNum(prev => Math.min(prev + 1, collabTotalPages))} disabled={collabPageNum === collabTotalPages || collabTotalPages === 0}>NEXT</button>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )}



            </main>







            {isCollabModalOpen && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
                }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '400px', maxWidth: '90%', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                        <h3 style={{ margin: '0 0 16px 0', fontSize: '16px', color: colors.darkNavy }}>
                            {activeCollabItem ? 'EDIT COLLABORATOR' : 'ADD NEW COLLABORATOR'}
                        </h3>

                        <form onSubmit={handleCollabFormSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                            <div>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: 'bold', marginBottom: '4px', color: '#475569' }}>Name</label>
                                <input
                                    type="text"
                                    required
                                    value={collabFormData.name}
                                    onChange={(e) => setCollabFormData({ ...collabFormData, name: e.target.value })}
                                    style={{ width: '100%', padding: '8px', fontSize: '12px', borderRadius: '4px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }}
                                />
                            </div>

                            <div>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: 'bold', marginBottom: '4px', color: '#475569' }}>Role</label>
                                <input
                                    type="text"
                                    required
                                    value={collabFormData.role}
                                    onChange={(e) => setCollabFormData({ ...collabFormData, role: e.target.value })}
                                    style={{ width: '100%', padding: '8px', fontSize: '12px', borderRadius: '4px', border: '1px solid #cbd5e1', boxSizing: 'border-box' }}
                                />
                            </div>

                            <div>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: 'bold', marginBottom: '4px', color: '#475569' }}>Introduction</label>
                                <textarea
                                    rows="3"
                                    value={collabFormData.introduction}
                                    onChange={(e) => setCollabFormData({ ...collabFormData, introduction: e.target.value })}
                                    style={{ width: '100%', padding: '8px', fontSize: '12px', borderRadius: '4px', border: '1px solid #cbd5e1', boxSizing: 'border-box', resize: 'vertical' }}
                                />
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '12px' }}>
                                <button
                                    type="button"
                                    onClick={handleCloseCollabModal}
                                    style={{ padding: '8px 12px', background: '#cbd5e1', color: '#334155', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold' }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    style={{ padding: '8px 12px', background: colors.deepBlue, color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px', fontWeight: 'bold' }}
                                >
                                    {activeCollabItem ? 'Update Changes' : 'Save Record'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {isBannerModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '100%', maxWidth: '450px', maxHeight: '90vh', overflowY: 'auto', border: `2px solid ${colors.goldenYellow}`, boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
                        <h3 style={{ fontSize: '14px', fontWeight: '800', color: colors.darkNavy, margin: '0 0 16px 0', textTransform: 'uppercase' }}>
                            {bannerEditingId !== null ? 'EDIT BANNER' : 'ADD NEW BANNER'}
                        </h3>
                        <form onSubmit={handleBannerFormSubmit}>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Banner Image File</label>
                                <input type="file" accept="image/*" onChange={(e) => setBannerForm({ ...bannerForm, bannerImage: e.target.files[0] })} style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Tag</label>
                                <input type="text" value={bannerForm.tag} onChange={(e) => setBannerForm({ ...bannerForm, tag: e.target.value })} placeholder="Disaster Relief" style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Headline (Title)</label>
                                <input type="text" value={bannerForm.title} onChange={(e) => setBannerForm({ ...bannerForm, title: e.target.value })} placeholder="Enter title" style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Sub (Description)</label>
                                <textarea value={bannerForm.description} onChange={(e) => setBannerForm({ ...bannerForm, description: e.target.value })} placeholder="Enter description..." rows="2" style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Primary Button Name</label>
                                <input type="text" value={bannerForm.buttonName1} onChange={(e) => setBannerForm({ ...bannerForm, buttonName1: e.target.value })} placeholder="Donate Now" style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>CTA URL (Primary Button)</label>
                                <input type="text" value={bannerForm.cta} onChange={(e) => setBannerForm({ ...bannerForm, cta: e.target.value })} placeholder="https://..." style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Secondary Button Name</label>
                                <input type="text" value={bannerForm.buttonName2} onChange={(e) => setBannerForm({ ...bannerForm, buttonName2: e.target.value })} placeholder="Learn More" style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>CTA Secondary URL (Secondary Button)</label>
                                <input type="text" value={bannerForm.ctaSecondary} onChange={(e) => setBannerForm({ ...bannerForm, ctaSecondary: e.target.value })} placeholder="https://..." style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button type="submit" style={{ flex: 1, padding: '10px', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', fontWeight: '700', cursor: 'pointer', textTransform: 'uppercase' }}>{bannerEditingId !== null ? 'UPDATE' : 'SAVE'}</button>
                                <button type="button" style={{ flex: 1, padding: '10px', backgroundColor: '#cbd5e1', color: colors.darkNavy, border: 'none', borderRadius: '6px', fontWeight: '700', cursor: 'pointer', textTransform: 'uppercase' }} onClick={handleCloseBannerModal}>CANCEL</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Modal Form for Add / Edit */}
            {isModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '100%', maxWidth: '400px', border: `2px solid ${colors.goldenYellow}`, boxShadow: '0 10px 30px rgba(0,0,0,0.2)', boxSizing: 'border-box', }}>
                        <h3 style={{ fontSize: '14px', fontWeight: '800', color: colors.darkNavy, margin: '0 0 16px 0', textTransform: 'uppercase', }}>{editingId !== null ? 'EDIT DISTRICT' : 'ADD NEW DISTRICT'}</h3>
                        <form onSubmit={handleFormSubmit}>
                            <div style={{ marginBottom: '16px', }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase', }}>District</label>
                                <input type="text" value={formData.district} onChange={(e) => setFormData({ ...formData, district: e.target.value })} placeholder="e.g. 321" style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none', }} />
                            </div>
                            <div style={{ marginBottom: '16px', }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase', }}>District Name</label>
                                <input type="text" value={formData.districtName} onChange={(e) => setFormData({ ...formData, districtName: e.target.value })} placeholder="e.g. Central District" style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none', }} />
                            </div>
                            <div style={{ marginBottom: '16px', }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase', }}>Clubs</label>
                                <input type="number" value={formData.clubs} onChange={(e) => setFormData({ ...formData, clubs: e.target.value })} placeholder="e.g. 24" style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none', }} />
                            </div>
                            <div style={{ marginBottom: '16px', }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase', }}>Members</label>
                                <input type="number" value={formData.members} onChange={(e) => setFormData({ ...formData, members: e.target.value })} placeholder="e.g. 1200" style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none', }} />
                            </div>
                            <div style={{ marginBottom: '16px', }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase', }}>District Chairperson</label>
                                <input type="text" value={formData.districtChairperson} onChange={(e) => setFormData({ ...formData, districtChairperson: e.target.value })} placeholder="e.g. John Doe" style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none', }} />
                            </div>
                            <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                                <button type="submit" style={{ width: '100%', padding: '10px', fontSize: '12px', fontWeight: '700', color: colors.darkNavy, backgroundColor: colors.goldenYellow, border: 'none', borderRadius: '8px', cursor: 'pointer', marginTop: '4px', textTransform: 'uppercase', letterSpacing: '0.05em', flex: 1 }}>
                                    {editingId !== null ? 'UPDATE' : 'SAVE'}
                                </button>
                                <button type="button" style={{ flex: 1, padding: '10px', fontSize: '11px', fontWeight: '700', backgroundColor: '#cbd5e1', color: colors.darkNavy, border: 'none', borderRadius: '8px', cursor: 'pointer', textTransform: 'uppercase', }} onClick={handleCloseModal}>
                                    CANCEL
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {isLeaderModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
                    <div style={{ backgroundColor: '#ffffff', padding: '24px', borderRadius: '12px', width: '400px', maxWidth: '90%', boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}>
                        <h3 style={{ marginTop: 0, marginBottom: '16px', color: '#1f2937', fontSize: '18px' }}>
                            {editingLeaderId !== null ? 'EDIT LEADER' : 'ADD NEW LEADER'}
                        </h3>
                        <form onSubmit={handleLeaderFormSubmit}>
                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#4b5563', marginBottom: '6px' }}>Upload Image File</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setLeaderImageFile(e.target.files[0])}
                                    style={{ width: '100%', padding: '8px', fontSize: '14px', border: '1px solid #d1d5db', borderRadius: '6px', boxSizing: 'border-box' }}
                                />
                            </div>
                            <div style={{ marginBottom: '14px' }}>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#4b5563', marginBottom: '6px' }}>Name</label>
                                <input
                                    type="text"
                                    value={leaderForm.name}
                                    onChange={(e) => setLeaderForm({ ...leaderForm, name: e.target.value })}
                                    placeholder="e.g. John Doe"
                                    style={{ width: '100%', padding: '10px', fontSize: '14px', border: '1px solid #d1d5db', borderRadius: '6px', boxSizing: 'border-box' }}
                                />
                            </div>
                            <div style={{ marginBottom: '20px' }}>
                                <label style={{ display: 'block', fontSize: '12px', fontWeight: 'bold', color: '#4b5563', marginBottom: '6px' }}>Designation</label>
                                <input
                                    type="text"
                                    value={leaderForm.designation}
                                    onChange={(e) => setLeaderForm({ ...leaderForm, designation: e.target.value })}
                                    placeholder="e.g. District Governor"
                                    style={{ width: '100%', padding: '10px', fontSize: '14px', border: '1px solid #d1d5db', borderRadius: '6px', boxSizing: 'border-box' }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button type="submit" style={{ flex: 1, backgroundColor: '#0066a6', color: '#ffffff', border: 'none', padding: '10px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }}>
                                    {editingLeaderId !== null ? 'UPDATE' : 'SAVE'}
                                </button>
                                <button type="button" style={{ backgroundColor: '#e5e7eb', color: '#374151', border: 'none', padding: '10px 16px', borderRadius: '6px', fontWeight: 'bold', cursor: 'pointer' }} onClick={() => setIsLeaderModalOpen(false)}>
                                    CANCEL
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {isProgramModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '100%', maxWidth: '400px', border: `2px solid ${colors.goldenYellow}` }}>
                        <h2 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '16px', textTransform: 'uppercase', color: colors.darkNavy }}>{editingProgramId !== null ? 'Edit Program' : 'Add New Program'}</h2>
                        <form onSubmit={handleProgramFormSubmit}>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '4px' }}> Service Activity *</label>
                                <select value={programForm.serviceActivity} onChange={(e) => { setProgramForm({ ...programForm, serviceActivity: e.target.value }); }} required style={{ width: '100%', padding: '8px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '12px', boxSizing: 'border-box', backgroundColor: colors.white }}>
                                    <option value="">SELECT SERVICE ACTIVITY</option>
                                    {serviceActivities.map((activity) => (
                                        <option key={activity} value={activity}>{activity}</option>
                                    ))}
                                </select>
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '4px' }}>Title *</label>
                                <input type="text" value={programForm.title} onChange={(e) => { setProgramForm({ ...programForm, title: e.target.value }); }} placeholder="Program Title" required style={{ width: '100%', padding: '8px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '12px', boxSizing: 'border-box' }} />
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '4px' }}>Description *</label>
                                <textarea value={programForm.description} onChange={(e) => { setProgramForm({ ...programForm, description: e.target.value }); }} placeholder="Program description..." rows="4" required style={{ width: '100%', padding: '8px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '12px', boxSizing: 'border-box', resize: 'vertical' }} />
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                <button type="button" onClick={() => { setIsProgramModalOpen(false); setEditingProgramId(null); }} style={{ padding: '6px 12px', backgroundColor: '#e2e8f0', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: '700' }}>Cancel</button>
                                <button type="submit" style={{ padding: '6px 12px', backgroundColor: colors.royalBlue, color: colors.white, border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: '700' }}>{editingProgramId !== null ? 'Update' : 'Save'}</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {isDistrictModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, overflowY: 'auto', padding: '20px' }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '100%', maxWidth: '460px', border: `2px solid ${colors.goldenYellow}` }}>
                        <h2 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '16px', textTransform: 'uppercase', color: colors.darkNavy }}>
                            {editingDistrictId !== null ? 'Edit District' : 'Add New District'}
                        </h2>

                        <form onSubmit={handleDistrictFormSubmit}>
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '3px' }}>District Name</label>
                                <input type="text" value={districtForm.district_name} onChange={(e) => setDistrictForm({ district_name: e.target.value })} placeholder="e.g. 320A" style={{ width: '100%', padding: '7px 10px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '11px', boxSizing: 'border-box' }} />
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                <button type="button" onClick={() => setIsDistrictModalOpen(false)} style={{ padding: '6px 12px', backgroundColor: '#e2e8f0', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: '700', fontSize: '11px' }}>Cancel</button>
                                <button type="submit" style={{ padding: '6px 12px', backgroundColor: colors.royalBlue, color: colors.white, border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: '700', fontSize: '11px' }}>Save</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}


            {isLeaderModalOpenteam && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, overflowY: 'auto', padding: '20px' }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '100%', maxWidth: '460px', border: `2px solid ${colors.goldenYellow}`, maxHeight: '90vh', overflowY: 'auto' }}>
                        <h2 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '16px', textTransform: 'uppercase', color: colors.darkNavy }}>
                            {editingLeaderteamId !== null ? 'Edit District Leader' : 'Add New District Leader'}
                        </h2>
                        <form onSubmit={handleLeaderFormSubmitteam}>
                            <div style={{ marginBottom: '8px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700' }}>District Name</label>
                                <input type="text" value={leaderFormteam.districtName} onChange={e => setLeaderFormteam({ ...leaderFormteam, districtName: e.target.value })} placeholder="e.g. 320A" style={{ width: '100%', padding: '6px' }} />
                            </div>

                            <div style={{ marginBottom: '8px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700' }}>Label Code</label>
                                <input type="text" value={leaderFormteam.label} onChange={e => setLeaderFormteam({ ...leaderFormteam, label: e.target.value })} placeholder="e.g. 320A" style={{ width: '100%', padding: '6px' }} />
                            </div>

                            <div style={{ marginBottom: '8px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700' }}>Region</label>
                                <input type="text" value={leaderFormteam.region} onChange={e => setLeaderFormteam({ ...leaderFormteam, region: e.target.value })} placeholder="Northern Region" style={{ width: '100%', padding: '6px' }} />
                            </div>

                            <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>Clubs Count</label>
                                    <input type="number" value={leaderFormteam.clubs} onChange={e => setLeaderFormteam({ ...leaderFormteam, clubs: e.target.value })} placeholder="152" style={{ width: '100%', padding: '6px' }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>Members Count</label>
                                    <input type="number" value={leaderFormteam.members} onChange={e => setLeaderFormteam({ ...leaderFormteam, members: e.target.value })} placeholder="6100" style={{ width: '100%', padding: '6px' }} />
                                </div>
                            </div>

                            <div style={{ marginBottom: '8px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700' }}>Governor Name</label>
                                <input type="text" value={leaderFormteam.name} onChange={e => setLeaderFormteam({ ...leaderFormteam, name: e.target.value })} placeholder="Dr. G Mahendera Kumar Reddy" style={{ width: '100%', padding: '6px' }} />
                            </div>

                            <div style={{ marginBottom: '8px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700' }}>Designation</label>
                                <input type="text" value={leaderFormteam.designation} onChange={e => setLeaderFormteam({ ...leaderFormteam, designation: e.target.value })} placeholder="District Governor" style={{ width: '100%', padding: '6px' }} />
                            </div>

                            <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>Gov Mobile</label>
                                    <input type="text" value={leaderFormteam.mobile} onChange={e => setLeaderFormteam({ ...leaderFormteam, mobile: e.target.value })} placeholder="9848219972" style={{ width: '100%', padding: '6px' }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>District Email</label>
                                    <input type="email" value={leaderFormteam.email} onChange={e => setLeaderFormteam({ ...leaderFormteam, email: e.target.value })} placeholder="320a@md320.org" style={{ width: '100%', padding: '6px' }} />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>Established Year</label>
                                    <input type="text" value={leaderFormteam.established} onChange={e => setLeaderFormteam({ ...leaderFormteam, established: e.target.value })} placeholder="1952" style={{ width: '100%', padding: '6px' }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>Tagline</label>
                                    <input type="text" value={leaderFormteam.tagline} onChange={e => setLeaderFormteam({ ...leaderFormteam, tagline: e.target.value })} placeholder="Serving Communities" style={{ width: '100%', padding: '6px' }} />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>1st Vice Dist Governor (FVDG)</label>
                                    <input type="text" value={leaderFormteam.fvdg} onChange={e => setLeaderFormteam({ ...leaderFormteam, fvdg: e.target.value })} placeholder="Lion Suresh Jagnani" style={{ width: '100%', padding: '6px' }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>FVDG Mobile</label>
                                    <input type="text" value={leaderFormteam.fvdgMobile} onChange={e => setLeaderFormteam({ ...leaderFormteam, fvdgMobile: e.target.value })} placeholder="9885189821" style={{ width: '100%', padding: '6px' }} />
                                </div>
                            </div>

                            <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>2nd Vice Dist Governor (SVDG)</label>
                                    <input type="text" value={leaderFormteam.svdg} onChange={e => setLeaderFormteam({ ...leaderFormteam, svdg: e.target.value })} placeholder="Dr. K Shashikant" style={{ width: '100%', padding: '6px' }} />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <label style={{ fontSize: '10px', fontWeight: '700' }}>SVDG Mobile</label>
                                    <input type="text" value={leaderFormteam.svdgMobile} onChange={e => setLeaderFormteam({ ...leaderFormteam, svdgMobile: e.target.value })} placeholder="9440210107" style={{ width: '100%', padding: '6px' }} />
                                </div>
                            </div>
                            {/* 16. Governor Image & Preview */}
                            <div style={{ marginBottom: '8px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700' }}>Governor Image</label>
                                <input type="file" accept="image/*" onChange={handleProfileImageChange} style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }} />
                                {imagePreview && (<img src={imagePreview} alt="Governor Preview" style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />)}
                            </div>
                            {/* 17. FVDG Image & Preview */}
                            <div style={{ marginBottom: '8px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700' }}>FVDG Image</label>
                                <input type="file" accept="image/*" onChange={handleFvdgImageChange} style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }} />
                                {fvdgImagePreview && (<img src={fvdgImagePreview} alt="FVDG Preview" style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />)}
                            </div>
                            {/* 18. SVDG Image & Preview */}
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700' }}>SVDG Image</label>
                                <input type="file" accept="image/*" onChange={handleSvdgImageChange} style={{ fontSize: '10px', display: 'block', marginBottom: '4px' }} />
                                {svdgImagePreview && (<img src={svdgImagePreview} alt="SVDG Preview" style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }} />)}
                            </div>
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                <button type="button" onClick={() => setIsLeaderModalOpenteam(false)} style={{ padding: '6px 12px', background: '#cbd5e1', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Cancel</button>
                                <button type="submit" style={{ padding: '6px 12px', background: '#2563eb', color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer' }}>Save Record</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {isMdModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, overflowY: 'auto', padding: '20px' }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '100%', maxWidth: '460px', border: `2px solid ${colors.goldenYellow}`, maxHeight: '90vh', overflowY: 'auto' }}>
                        <h2 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '16px', textTransform: 'uppercase', color: colors.darkNavy }}>
                            {editingMdId !== null ? 'Edit Multiple District' : 'Add New Multiple District'}
                        </h2>
                        <form onSubmit={handleMdFormSubmit}>

                            {/* Input 1: Title */}
                            <div style={{ marginBottom: '10px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '3px' }}>Title</label>
                                <input
                                    type="text"
                                    value={mdForm.title}
                                    onChange={(e) => setMdForm({ ...mdForm, title: e.target.value })}
                                    placeholder="e.g. Multiple District 320"
                                    style={{ width: '100%', padding: '7px 10px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '11px', boxSizing: 'border-box' }}
                                />
                            </div>

                            {/* Input 2: Description */}
                            <div style={{ marginBottom: '10px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '3px' }}>Description</label>
                                <textarea
                                    value={mdForm.description}
                                    onChange={(e) => setMdForm({ ...mdForm, description: e.target.value })}
                                    placeholder="Enter brief description..."
                                    rows="3"
                                    style={{ width: '100%', padding: '7px 10px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '11px', boxSizing: 'border-box', resize: 'vertical' }}
                                />
                            </div>

                            {/* Input 3: Districts */}
                            <div style={{ marginBottom: '10px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '3px' }}>Districts</label>
                                <input
                                    type="text"
                                    value={mdForm.districts}
                                    onChange={(e) => setMdForm({ ...mdForm, districts: e.target.value })}
                                    placeholder="e.g. 320A, 320B, 320C"
                                    style={{ width: '100%', padding: '7px 10px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '11px', boxSizing: 'border-box' }}
                                />
                            </div>

                            {/* Input 4: Total Clubs */}
                            <div style={{ marginBottom: '10px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '3px' }}>Total Clubs</label>
                                <input
                                    type="number"
                                    value={mdForm.totalClubs}
                                    onChange={(e) => setMdForm({ ...mdForm, totalClubs: e.target.value })}
                                    placeholder="e.g. 150"
                                    style={{ width: '100%', padding: '7px 10px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '11px', boxSizing: 'border-box' }}
                                />
                            </div>

                            {/* Input 5: Total Members */}
                            <div style={{ marginBottom: '10px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '3px' }}>Total Members</label>
                                <input
                                    type="number"
                                    value={mdForm.totalMembers}
                                    onChange={(e) => setMdForm({ ...mdForm, totalMembers: e.target.value })}
                                    placeholder="e.g. 5000"
                                    style={{ width: '100%', padding: '7px 10px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '11px', boxSizing: 'border-box' }}
                                />
                            </div>

                            {/* Input 6: Fiscal Year */}
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '10px', fontWeight: '700', marginBottom: '3px' }}>Fiscal Year</label>
                                <input
                                    type="text"
                                    value={mdForm.fiscalYear}
                                    onChange={(e) => setMdForm({ ...mdForm, fiscalYear: e.target.value })}
                                    placeholder="e.g. 2026-2027"
                                    style={{ width: '100%', padding: '7px 10px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', fontSize: '11px', boxSizing: 'border-box' }}
                                />
                            </div>

                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                <button
                                    type="button"
                                    onClick={() => setIsMdModalOpen(false)}
                                    style={{ padding: '6px 12px', backgroundColor: '#e2e8f0', border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: '700', fontSize: '11px' }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    style={{ padding: '6px 12px', backgroundColor: colors.royalBlue, color: colors.white, border: 'none', borderRadius: '4px', cursor: 'pointer', fontWeight: '700', fontSize: '11px' }}
                                >
                                    Save
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {ourTeam_isModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '100%', maxWidth: '400px', border: `2px solid ${colors.goldenYellow}` }}>
                        <h2 style={{ fontSize: '14px', fontWeight: '700', marginBottom: '16px', textTransform: 'uppercase', color: colors.darkNavy }}>
                            {ourTeam_editingId !== null ? 'Edit Team Member' : 'Add Team Member'}
                        </h2>
                        <form onSubmit={handleOurTeamSubmit}>
                            {/* Input 1: Name */}
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700', display: 'block', marginBottom: '4px' }}>Name</label>
                                <input
                                    type="text"
                                    value={ourTeam_form.name}
                                    onChange={e => setOurTeam_form({ ...ourTeam_form, name: e.target.value })}
                                    placeholder="Enter full name"
                                    style={{ width: '100%', padding: '8px', fontSize: '11px', borderRadius: '4px', border: '1px solid #cbd5e1', outline: 'none' }}
                                />
                            </div>

                            {/* Input 2: Designation */}
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700', display: 'block', marginBottom: '4px' }}>Designation</label>
                                <input
                                    type="text"
                                    value={ourTeam_form.designation}
                                    onChange={e => setOurTeam_form({ ...ourTeam_form, designation: e.target.value })}
                                    placeholder="Enter designation (e.g. Coordinator)"
                                    style={{ width: '100%', padding: '8px', fontSize: '11px', borderRadius: '4px', border: '1px solid #cbd5e1', outline: 'none' }}
                                />
                            </div>

                            {/* Input 3: Profile Image & Preview */}
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ fontSize: '10px', fontWeight: '700', display: 'block', marginBottom: '4px' }}>Profile Image</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleOurTeamImageChange}
                                    style={{ fontSize: '10px', display: 'block', marginBottom: '8px' }}
                                />
                                {ourTeam_imagePreview && (
                                    <img
                                        src={ourTeam_imagePreview}
                                        alt="Preview"
                                        style={{ width: '45px', height: '45px', borderRadius: '50%', objectFit: 'cover', border: '1px solid #cbd5e1' }}
                                    />
                                )}
                            </div>

                            {/* Actions */}
                            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}>
                                <button type="button" onClick={() => setOurTeam_isModalOpen(false)} style={{ padding: '6px 12px', background: '#cbd5e1', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px' }}>Cancel</button>
                                <button type="submit" style={{ padding: '6px 12px', background: colors.royalBlue, color: '#fff', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '11px', fontWeight: '700' }}>Save Record</button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {isEditActivityModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '100%', maxWidth: '400px', border: `2px solid ${colors.goldenYellow}`, boxShadow: '0 10px 30px rgba(0,0,0,0.2)', boxSizing: 'border-box' }}>
                        <h3 style={{ fontSize: '14px', fontWeight: '800', color: colors.darkNavy, margin: '0 0 16px 0', textTransform: 'uppercase' }}>
                            Edit Activity
                        </h3>
                        <form onSubmit={handleUpdateActivitySubmit}>
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase' }}>District</label>
                                <input
                                    type="text"
                                    value={activityFormData.district}
                                    onChange={(e) => setActivityFormData({ ...activityFormData, district: e.target.value })}
                                    style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none' }}
                                />
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase' }}>Activity Name</label>
                                <input
                                    type="text"
                                    value={activityFormData.activity}
                                    onChange={(e) => setActivityFormData({ ...activityFormData, activity: e.target.value })}
                                    style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none' }}
                                />
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase' }}>Caption</label>
                                <input
                                    type="text"
                                    value={activityFormData.caption}
                                    onChange={(e) => setActivityFormData({ ...activityFormData, caption: e.target.value })}
                                    style={{ width: '100%', padding: '10px 12px', fontSize: '12px', color: colors.darkNavy, backgroundColor: colors.white, border: `1px solid ${colors.deepBlue}`, borderRadius: '8px', boxSizing: 'border-box', outline: 'none' }}
                                />
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', color: colors.darkNavy, marginBottom: '6px', textTransform: 'uppercase' }}>Update Photo (Optional)</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => setActivityFormData({ ...activityFormData, photo: e.target.files[0] })}
                                    style={{ width: '100%', fontSize: '11px', color: colors.darkNavy }}
                                />
                            </div>
                            <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                                <button type="submit" style={{ width: '100%', padding: '10px', fontSize: '12px', fontWeight: '700', color: colors.darkNavy, backgroundColor: colors.goldenYellow, border: 'none', borderRadius: '8px', cursor: 'pointer', textTransform: 'uppercase', flex: 1 }}>
                                    UPDATE
                                </button>
                                <button type="button" style={{ flex: 1, padding: '10px', fontSize: '11px', fontWeight: '700', backgroundColor: '#cbd5e1', color: colors.darkNavy, border: 'none', borderRadius: '8px', cursor: 'pointer', textTransform: 'uppercase' }} onClick={() => setIsEditActivityModalOpen(false)}>
                                    CANCEL
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Edit Contact Message Modal */}
            {isContactMessageModalOpen && (
                <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000, padding: '20px' }}>
                    <div style={{ backgroundColor: colors.white, padding: '24px', borderRadius: '12px', width: '100%', maxWidth: '450px', border: `2px solid ${colors.goldenYellow}`, boxShadow: '0 10px 30px rgba(0,0,0,0.2)' }}>
                        <h3 style={{ fontSize: '14px', fontWeight: '800', color: colors.darkNavy, margin: '0 0 16px 0', textTransform: 'uppercase' }}>
                            EDIT MESSAGE
                        </h3>
                        <form onSubmit={handleContactMessageFormSubmit}>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Name</label>
                                <input type="text" value={contactMessageForm.name} onChange={(e) => setContactMessageForm({ ...contactMessageForm, name: e.target.value })} style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} required />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Email</label>
                                <input type="email" value={contactMessageForm.email} onChange={(e) => setContactMessageForm({ ...contactMessageForm, email: e.target.value })} style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} required />
                            </div>
                            <div style={{ marginBottom: '12px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Subject</label>
                                <input type="text" value={contactMessageForm.subject} onChange={(e) => setContactMessageForm({ ...contactMessageForm, subject: e.target.value })} style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box' }} required />
                            </div>
                            <div style={{ marginBottom: '16px' }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '700', marginBottom: '4px', textTransform: 'uppercase' }}>Message</label>
                                <textarea value={contactMessageForm.message} onChange={(e) => setContactMessageForm({ ...contactMessageForm, message: e.target.value })} rows="4" style={{ width: '100%', padding: '8px', fontSize: '12px', border: `1px solid ${colors.deepBlue}`, borderRadius: '6px', boxSizing: 'border-box', resize: 'vertical' }} required />
                            </div>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button type="submit" style={{ flex: 1, padding: '10px', backgroundColor: colors.goldenYellow, color: colors.darkNavy, border: 'none', borderRadius: '6px', fontWeight: '700', cursor: 'pointer', textTransform: 'uppercase' }}>
                                    UPDATE
                                </button>
                                <button type="button" style={{ flex: 1, padding: '10px', backgroundColor: '#cbd5e1', color: colors.darkNavy, border: 'none', borderRadius: '6px', fontWeight: '700', cursor: 'pointer', textTransform: 'uppercase' }} onClick={handleCloseContactMessageModal}>
                                    CANCEL
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default AdminApp;